/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface MicrosoftAspNetCoreMvcProblemDetails {
  type?: string | null;
  title?: string | null;

  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
}

export interface SravniMicroErrorsError {
  code?: string | null;
  target?: string | null;
  message?: string | null;
  description?: string | null;
  attemptedValue?: string | null;
  details?: SravniMicroErrorsError[] | null;
}

export interface SravniMicroErrorsErrorModel {
  error?: SravniMicroErrorsError;
}

export enum SravniOrganizationsSharedOrganizationType {
  Unknown = 'unknown',
  Bank = 'bank',
  Insurance = 'insurance',
  Mfo = 'mfo',
  EducationalOrganization = 'educationalOrganization',
  Broker = 'broker',
  Npf = 'npf',
  Leasing = 'leasing',
  Marketplace = 'marketplace',
  Bankruptcy = 'bankruptcy',
  University = 'university',
  Bookmaker = 'bookmaker',
  Investment = 'investment',
  NonbankingOrganization = 'nonbankingOrganization',
  MortgageAgent = 'mortgageAgent',
  Other = 'other',
  FoodRation = 'foodRation',
}

export enum SravniOrganizationsSharedReviewObjectType {
  Unknown = 'unknown',
  Banks = 'banks',
  InsuranceCompany = 'insuranceCompany',
  CarService = 'carService',
  CarModel = 'carModel',
  Mfi = 'mfi',
  EducationalOrganization = 'educationalOrganization',
  Broker = 'broker',
  Npf = 'npf',
  Leasing = 'leasing',
  Marketplace = 'marketplace',
  Bankruptcy = 'bankruptcy',
  University = 'university',
  Bookmaker = 'bookmaker',
  Investment = 'investment',
  FoodRation = 'foodRation',
}

export interface SravniReviewsAttachmentsAttachmentWithContentModel {
  /** @format uuid */
  id?: string;

  /** @format date-time */
  created?: string;
  name?: string | null;
  extension?: string | null;
  url?: string | null;
  path?: string | null;

  /** @format byte */
  content?: string | null;
}

export interface SravniReviewsClientToOrganizationModel {
  /** @format int32 */
  id?: number;
  clientId?: string | null;
  organizationId?: string | null;
  deleted?: boolean;
}

/**
 * Команда нотификации о создании отзыва
 */
export interface SravniReviewsCommandsReviewCreatedOrUpdatedCommand {
  /**
   * Идентификатор отзыва
   * @format int32
   */
  id?: number;
}

export enum SravniReviewsEnumsActivityEventType {
  None = 'none',
  ReviewAdded = 'reviewAdded',
  ReviewEdited = 'reviewEdited',
  ReviewDeleted = 'reviewDeleted',
  ReviewChecked = 'reviewChecked',
  CommentAdded = 'commentAdded',
  CommentEdited = 'commentEdited',
  CommentDeleted = 'commentDeleted',
  CommentChecked = 'commentChecked',
  RatingAccepted = 'ratingAccepted',
  RatingChanged = 'ratingChanged',
  RatingRejected = 'ratingRejected',
  ProblemSolved = 'problemSolved',
  ReviewFollowUp = 'reviewFollowUp',
  DocumentsRequested = 'documentsRequested',
  DocumentsRecieved = 'documentsRecieved',
  DocumentsRemoved = 'documentsRemoved',
  DocumentsRequestCancelled = 'documentsRequestCancelled',
  DocumentsApproved = 'documentsApproved',
  DocumentsFailed = 'documentsFailed',
  ReviewRestored = 'reviewRestored',
  CommentRestored = 'commentRestored',
  ProblemSolutionReset = 'problemSolutionReset',
  ReviewUnchecked = 'reviewUnchecked',
  CommentUnchecked = 'commentUnchecked',
  ReviewObjectTypeChanged = 'reviewObjectTypeChanged',
  ReviewPreModerationApproved = 'reviewPreModerationApproved',
  CommentPreModerationApproved = 'commentPreModerationApproved',
  ReviewTagAdded = 'reviewTagAdded',
  ReviewTagRemoved = 'reviewTagRemoved',
  ReviewTagChanged = 'reviewTagChanged',
  DocumentsChanged = 'documentsChanged',
  AutomaticCommentDeleted = 'automaticCommentDeleted',
  DocumentsRequestedAgain = 'documentsRequestedAgain',
  HasCompanyResponse = 'hasCompanyResponse',
  ReviewAutoModerationRequested = 'reviewAutoModerationRequested',
}

/**
 * Тип сортировки комментариев
 */
export enum SravniReviewsEnumsCommentsOrderBy {
  Created = 'created',
}

export enum SravniReviewsEnumsDateInterval {
  Day = 'day',
  Week = 'week',
  Month = 'month',
  Quarter = 'quarter',
  Year = 'year',
}

/**
 * Причина удаления отзыва
 */
export enum SravniReviewsEnumsDeleteReason {
  Other = 'other',
  Spam = 'spam',
}

/**
 * Тип удаления комментария
 */
export enum SravniReviewsEnumsDeletedCommentsByRoleType {
  DeleteByUser = 'deleteByUser',
  DeleteByRepresentative = 'deleteByRepresentative',
  DeleteByModerator = 'deleteByModerator',
}

export enum SravniReviewsEnumsExternalApiActivityEventType {
  ReviewEdited = 'reviewEdited',
  ReviewChecked = 'reviewChecked',
  CommentAdded = 'commentAdded',
  CommentEdited = 'commentEdited',
  RatingAccepted = 'ratingAccepted',
  RatingChanged = 'ratingChanged',
  RatingRejected = 'ratingRejected',
  ProblemSolved = 'problemSolved',
  ProblemSolutionReset = 'problemSolutionReset',
}

export enum SravniReviewsEnumsLocationRatingType {
  WithOrganizations = 'withOrganizations',
  WithService = 'withService',
  WithSpecificProduct = 'withSpecificProduct',
}

export enum SravniReviewsEnumsModerationReasonType {
  None = 'none',
  EmailContent = 'emailContent',
  PhoneContent = 'phoneContent',
  AbusiveContent = 'abusiveContent',
  AutoModerationRequested = 'autoModerationRequested',
  Spam = 'spam',
  Fraud = 'fraud',
  ImageContent = 'imageContent',
  Link = 'link',
  TransliterationContent = 'transliterationContent',
  UnreadableContent = 'unreadableContent',
  ImportedRequiresConfirmation = 'importedRequiresConfirmation',
  InvalidContentMatching = 'invalidContentMatching',
  Duplicate = 'duplicate',
}

/**
 * Тип сортировки
 */
export enum SravniReviewsEnumsOrderDirection {
  Asc = 'asc',
  Desc = 'desc',
}

/**
 * Энам для поиска по типу отзыва
 */
export enum SravniReviewsEnumsParsedReviewType {
  All = 'all',
  ParsedOnly = 'parsedOnly',
  NotParsedOnly = 'notParsedOnly',
}

export enum SravniReviewsEnumsRatingType {
  Default = 'default',
  OrganizationOnly = 'organizationOnly',
  ServiceTag = 'serviceTag',
  SpecificProduct = 'specificProduct',
  Locations = 'locations',
}

/**
 * Список полей для csv
 */
export enum SravniReviewsEnumsReputationDetailField {
  From = 'from',
  To = 'to',
  ReviewsCount = 'reviewsCount',
  ApprovedCount = 'approvedCount',
  RejectedCount = 'rejectedCount',
  AvgRatingValue = 'avgRatingValue',
  AnswersCount = 'answersCount',
  ResolvedCount = 'resolvedCount',
  AvgResponseTime = 'avgResponseTime',
  AvgResolvedTime = 'avgResolvedTime',
  PositiveVotesCount = 'positiveVotesCount',
  NegativeVotesCount = 'negativeVotesCount',
  ZeroRatingApprovedReviewsCount = 'zeroRatingApprovedReviewsCount',
  OneRatingApprovedReviewsCount = 'oneRatingApprovedReviewsCount',
  TwoRatingApprovedReviewsCount = 'twoRatingApprovedReviewsCount',
  ThreeRatingApprovedReviewsCount = 'threeRatingApprovedReviewsCount',
  FourRatingApprovedReviewsCount = 'fourRatingApprovedReviewsCount',
  FiveRatingApprovedReviewsCount = 'fiveRatingApprovedReviewsCount',
}

export enum SravniReviewsEnumsReputationGroupingType {
  Days = 'days',
  Weeks = 'weeks',
  Months = 'months',
  Years = 'years',
}

export enum SravniReviewsEnumsReviewAuthorRoleType {
  All = 'all',
  Users = 'users',
  Moderators = 'moderators',
  Representatives = 'representatives',
}

/**
 * Тип фильтрации отзывов
 */
export enum SravniReviewsEnumsReviewFilter {
  WithAnswers = 'withAnswers',
  WithRates = 'withRates',
  Resolved = 'resolved',
  RatesRejected = 'ratesRejected',
  All = 'all',
}

/**
 * Тип сортировки отзывов
 */
export enum SravniReviewsEnumsReviewOrder {
  ByDate = 'byDate',
  ByPopularity = 'byPopularity',
  HighRateFirst = 'highRateFirst',
  LowRateFirst = 'lowRateFirst',
  WithAnswers = 'withAnswers',
  WithRates = 'withRates',
  Checked = 'checked',
  Resolved = 'resolved',
  MostCommented = 'mostCommented',
  PartnersFirst = 'partnersFirst',
  ByDeleteDate = 'byDeleteDate',
}

/**
 * Тип оценки для фильтрации отзывов
 */
export enum SravniReviewsEnumsReviewRate {
  Any = 'any',
  One = 'one',
  Two = 'two',
  Three = 'three',
  Four = 'four',
  Five = 'five',
  Good = 'good',
  Bad = 'bad',
}

/**
 * Статусы проверки оценки отзыва
 */
export enum SravniReviewsEnumsReviewRateStatus {
  Unknown = 'unknown',
  RateNotAvailable = 'rateNotAvailable',
  RateChecking = 'rateChecking',
  RateApproved = 'rateApproved',
  RateModified = 'rateModified',
  RateRejected = 'rateRejected',
}

/**
 * статус отзыва
 */
export enum SravniReviewsEnumsReviewStatus {
  Unknown = 'unknown',
  Checking = 'checking',
  Checked = 'checked',
  PreModeration = 'preModeration',
}

export enum SravniReviewsEnumsUserDataStatus {
  None = 'none',
  Requested = 'requested',
  Received = 'received',
  Approved = 'approved',
  Rejected = 'rejected',
}

export interface SravniReviewsFilterInfo {
  /** @format int32 */
  id?: number;
  name?: string | null;
  alias?: string | null;
}

/**
 * Метаинформация файла в рамках системы отзывов
 */
export interface SravniReviewsIAttachment {
  /**
   * Идентификатор
   * @format uuid
   */
  id?: string;

  /**
   * Дата загрузки
   * @format date-time
   */
  created?: string;

  /** Наименование файла */
  name?: string | null;

  /** Расширение файла */
  extension?: string | null;

  /** Ссылка на файл */
  url?: string | null;

  /** Путь к файлу */
  path?: string | null;
}

export interface SravniReviewsICompanyDailyReviewAggregatedRating {
  /**
   * Количество с ответами
   * @format int32
   */
  withAnswers?: number;

  /**
   * Количество без ответов
   * @format int32
   */
  withoutAnswers?: number;

  /**
   * Среднее время ответа
   * @format int64
   */
  responseTimeTicks?: number;

  /**
   * Количество с решениями
   * @format int32
   */
  resolved?: number;

  /**
   * Количество без решений
   * @format int32
   */
  unresolved?: number;

  /**
   * Среднее время на решние вопроса
   * @format int64
   */
  resolutionTimeTicks?: number;

  /**
   * Количество зачтенных отзывов
   * @format int32
   */
  approved?: number;

  /**
   * Количество заблокированных отзывов
   * @format int32
   */
  blocked?: number;

  /**
   * null - признак не указан, либо общий расчет рейтинга
   * true - рейтинг по отзывам с признаком юридическое лицо
   * false - рейтинг по отзывам с признаком физическое лицо
   */
  isLegal?: boolean | null;

  /** @format double */
  complexCalculatedRatingValue?: number;
  organizationId?: string | null;
  organizationType?: SravniOrganizationsSharedReviewObjectType;

  /** @format double */
  ratingValue?: number;

  /** @format double */
  totalValue?: number;

  /** @format int32 */
  reviewTag?: number;
  specificProductId?: string | null;
  serviceCode?: string | null;

  /** @format int32 */
  participantsCount?: number;

  /**
   * Дата/Время создания
   * @format date-time
   */
  created?: string;
}

export interface SravniReviewsIntegrationIdentityReviewUserModel {
  /** @format int32 */
  userId?: number | null;
  authorEmail?: string | null;
  authorName?: string | null;
  authorLastName?: string | null;
  authorPhone?: string | null;
  companyId?: string | null;
  isBlocked?: boolean;
  isDeleted?: boolean;
  abPlatform?: string | null;
  reputationIsDemo?: boolean;
}

export interface SravniReviewsLocationData {
  /** @format int32 */
  id?: number;
  alias?: string | null;
  name?: string | null;
  fullName?: string | null;
  route?: string | null;

  /** @format double */
  latitude?: number | null;

  /** @format double */
  longitude?: number | null;
  nameLocative?: string | null;
}

export interface SravniReviewsLocationGarData {
  /** @format int32 */
  garId?: number;
  route?: string | null;
  name?: string | null;
  fullName?: string | null;

  /** @format double */
  latitude?: number | null;

  /** @format double */
  longitude?: number | null;
  nameLocative?: string | null;
}

/**
* Ужатая Модель для балк выгрузки статы в эксель
Нужна чтобы сервис не отлетал по OOM
*/
export interface SravniReviewsModelsActivityEventsReviewActivityEventLightModel {
  /** @format int32 */
  id?: number;
  activityEventType?: SravniReviewsEnumsActivityEventType;

  /** @format int32 */
  entityId?: number | null;

  /** @format int32 */
  reviewId?: number;
  userRole?: string | null;
  userContact?: string | null;

  /** @format int32 */
  userId?: number;
  organizationName?: string | null;
}

export interface SravniReviewsModelsActivityEventsReviewActivityEventModel {
  /** @format date-time */
  created?: string;

  /** @format int32 */
  id?: number;
  activityEventType?: SravniReviewsEnumsActivityEventType;

  /** @format int32 */
  entityId?: number | null;

  /** @format int32 */
  reviewId?: number;
  userRole?: string | null;
  userContact?: string | null;

  /** @format int32 */
  userId?: number;
  abPlatform?: string | null;
  organizationName?: string | null;
  oldValues?: SravniReviewsNameValueModel[] | null;
  newValues?: SravniReviewsNameValueModel[] | null;
}

export interface SravniReviewsModelsAutoModerationAutoModerationHistoryModel {
  /** @format int32 */
  id?: number;

  /** @format date-time */
  created?: string;

  /** @format int32 */
  targetReviewId?: number;

  /** @format int32 */
  autoModerationSettingId?: number;

  /** @format double */
  maxTotalEarnedScore?: number;
  suspectedReviewsInfos?: SravniReviewsModelsAutoModerationAutoModerationSuspectedReviewModel[] | null;
}

export interface SravniReviewsModelsAutoModerationAutoModerationSettingsModel {
  /** @format int32 */
  id?: number;

  /** @format date-time */
  created?: string;
  deleted?: boolean;

  /** @format double */
  userAgentScore?: number;

  /** @format double */
  cIpScore?: number;

  /** @format double */
  ipScore?: number;

  /** @format double */
  authorPhoneScore?: number;

  /** @format double */
  authorEmailScore?: number;

  /** @format double */
  authorNameScore?: number;

  /** @format double */
  authorLastNameScore?: number;

  /** @format double */
  locationIdScore?: number;

  /** @format double */
  totalScoresToSpam?: number;
}

/**
 * Информация о подозреваемом отзыве
 */
export interface SravniReviewsModelsAutoModerationAutoModerationSuspectedReviewModel {
  /**
   * Идентификатор проверяемой сущности
   * @format int32
   */
  suspectedReviewId?: number;

  /**
   * Очки подозрений за юзер-агент
   * @format double
   */
  earnedUserAgentScore?: number;

  /**
   * Очки подозрений за IP
   * @format double
   */
  earnedIpScore?: number;

  /**
   * Очки подозрений за CIp
   * @format double
   */
  earnedCIpScore?: number;

  /**
   * Очки подозрений за автора
   * @format double
   */
  earnedAuthorPhoneScore?: number;

  /**
   * Очки подозрений за автора
   * @format double
   */
  earnedAuthorEmailScore?: number;

  /**
   * Очки подозрений за имя автора
   * @format double
   */
  earnedAuthorNameScore?: number;

  /**
   * Очки подозрений за фамилию автора
   * @format double
   */
  earnedAuthorLastNameScore?: number;

  /**
   * Очки подозрений за локацию автора
   * @format double
   */
  earnedLocationIdScore?: number;

  /**
   * Сумма всех очков подозрений
   * @format double
   */
  totalEarnedScore?: number;
}

/**
 * Организация с наибольшим процентом решенных проблем
 */
export interface SravniReviewsModelsBestOrganizationsBestByPercentageOfSolvedProblems {
  organizationId?: string | null;

  /**
   * Процент решенных
   * @format double
   */
  percentageOfSolvedProblems?: number;

  /**
   * Кол-во решенных проблем
   * @format double
   */
  countOfResolvedProblems?: number;
}

/**
 * Организация  лучшим временем ответа
 */
export interface SravniReviewsModelsBestOrganizationsBestByResponseTime {
  organizationId?: string | null;

  /**
   * Время ответа в тиках
   * @format double
   */
  responseTime?: number;
}

/**
 * Организация с наибольшим количеством отзывов с ответами
 */
export interface SravniReviewsModelsBestOrganizationsBestByReviewsCountWithCompanyResponse {
  organizationId?: string | null;

  /** @format int32 */
  reviewsCountWithCompanyResponse?: number;

  /**
   * Процент отзывов с ответами
   * @format double
   */
  percentageOfReviewsWithCompanyResponse?: number;
}

/**
 * Модель лучших организаций по критериям
 */
export interface SravniReviewsModelsBestOrganizationsBestOrganizationsModel {
  /** Организация  лучшим временем ответа */
  bestResponseTime?: SravniReviewsModelsBestOrganizationsBestByResponseTime;

  /** Организация с наибольшим количеством отзывов с ответами */
  bestReviewsCountWithCompanyResponse?: SravniReviewsModelsBestOrganizationsBestByReviewsCountWithCompanyResponse;

  /** Организация с наибольшим процентом решенных проблем */
  bestByPercentageOfSolvedProblems?: SravniReviewsModelsBestOrganizationsBestByPercentageOfSolvedProblems;
}

export interface SravniReviewsModelsChartsAreaSeriesData {
  /** Individual data label for each point. The options are the same as the ones for  <a class="internal" href="#plotOptions.series.dataLabels">plotOptions.series.dataLabels</a> */
  dataLabel?: string | null;

  /**
   * <p>
   *   <i>Requires Accessibility module</i>
   * </p>
   * <p>A description of the point to add to the screen reader information about the point.</p>
   */
  description?: string | null;

  /** The ```id``` of a series in the <a href="#drilldown.series">drilldown.series</a> array to use for a drilldown for this point. */
  drilldown?: string | null;

  /** An id for the point. This can be used after render time to get a pointer to the point object through ```chart.get()```. */
  id?: string | null;

  /**
   * The rank for this point's data label in case of collision. If two data labels are about to overlap, only the one with the highest ```labelrank``` will be drawn.
   * @format double
   */
  labelRank?: number | null;

  /**
   * <p>The name of the point as shown in the legend, tooltip, dataLabel etc.</p>
   * <p>If the <a href="#xAxis.type">xAxis.type</a> is set to ```category```, and no <a href="#xAxis.categories">categories</a> option exists, the category will be pulled from the ```point.name``` of the last series defined. For multiple series, best practice however is to define ```xAxis.categories```.</p>
   */
  name?: string | null;

  /** Whether the data point is selected initially. */
  selected?: boolean | null;

  /**
   * The x value of the point. For datetime axes, the X value is the timestamp in milliseconds since 1970.
   * @format double
   */
  x?: number | null;

  /**
   * The y value of the point.
   * @format double
   */
  y?: number | null;
}

export interface SravniReviewsModelsChartsSeries {
  /** An id for the series. This can be used after render time to get a pointer to the series object through ```chart.get()```. */
  id?: string | null;

  /** The name of the series as shown in the legend, tooltip etc. */
  name?: string | null;

  /**
   * <p>If no x values are given for the points in a series, pointInterval defines the interval of the x values. For example, if a series contains one value every decade starting from year 0, set pointInterval to 10.</p>
   * <p>Since Highcharts 4.1, it can be combined with ```pointIntervalUnit``` to draw irregular intervals.</p>
   * @format double
   */
  pointInterval?: number | null;

  /**
   * If no x values are given for the points in a series, pointStart defines on what value to start. For example, if a series contains one yearly value starting from 1945, set pointStart to 1945.
   * @format double
   */
  pointStart?: number | null;

  /** This option allows grouping series in a stacked chart. The stack option can be a string  or a number or anything else, as long as the grouped series' stack options match each other. */
  stack?: string | null;
  type?: SravniReviewsModelsChartsTypeSeries;
  data?: SravniReviewsModelsChartsAreaSeriesData[] | null;
}

export enum SravniReviewsModelsChartsTypeSeries {
  Null = 'null',
  Line = 'line',
  Spline = 'spline',
  Column = 'column',
  Area = 'area',
  Areaspline = 'areaspline',
  Pie = 'pie',
  Arearange = 'arearange',
  Areasplinerange = 'areasplinerange',
  Boxplot = 'boxplot',
  Bubble = 'bubble',
  Columnrange = 'columnrange',
  Errorbar = 'errorbar',
  Funnel = 'funnel',
  Gauge = 'gauge',
  Scatter = 'scatter',
  Waterfall = 'waterfall',
  Bar = 'bar',
  Heatmap = 'heatmap',
  Pyramid = 'pyramid',
  Polygon = 'polygon',
  Treemap = 'treemap',
  Solidgauge = 'solidgauge',
  Bellcurve = 'bellcurve',
  Bullet = 'bullet',
  Histogram = 'histogram',
  Pareto = 'pareto',
  Sankey = 'sankey',
  Scatter3D = 'scatter3d',
  Streamgraph = 'streamgraph',
  Sunburst = 'sunburst',
  Tilemap = 'tilemap',
  Variablepie = 'variablepie',
  Variwide = 'variwide',
  Vector = 'vector',
  Windbarb = 'windbarb',
  Wordcloud = 'wordcloud',
  Xrange = 'xrange',
}

/**
 * Модель для создания конфигурации словаря
 */
export interface SravniReviewsModelsConfigurationsDictionaryConfigurationDictionaryCreateModel {
  /** Алиас(ключ) */
  alias: string;

  /** Значение в формате JSON */
  json: string;

  /** Описание */
  description?: string | null;
}

/**
 * Модель для получения элемента словаря
 */
export interface SravniReviewsModelsConfigurationsDictionaryConfigurationDictionaryModel {
  /**
   * Идентификатор
   * @format int32
   */
  id?: number;

  /** Алиас(ключ) */
  alias: string;

  /** Значение в формате JSON */
  json: string;

  /** Описание */
  description?: string | null;
}

/**
 * Модель для создания заметки
 */
export interface SravniReviewsModelsDelayedReviewDelayedReviewCreateModel {
  /**
   * Идентификатор отзыва
   * @format int32
   */
  reviewId?: number;
}

export interface SravniReviewsModelsDelayedReviewDelayedReviewModel {
  /**
   * Идентификатор заметки
   * @format int32
   */
  id?: number;

  /**
   * Идентификатор пользователя, чья заметка
   * @format int32
   */
  userId?: number;

  /**
   * Идентификатор отзыва с заметкой
   * @format int32
   */
  reviewId?: number;

  /**
   * Дата создания
   * @format date-time
   */
  created?: string;
}

export interface SravniReviewsModelsExternalApiExternalApiCommentModel {
  /**
   * Id
   * @format int32
   */
  id?: number;

  /**
   * Дата создания
   * @format date-time
   */
  created?: string;

  /**
   * Id автора
   * @format int32
   */
  authorId?: number | null;

  /** Имя автора */
  authorName?: string | null;

  /** Признак того, что комментарий от компании */
  isCompanyResponse?: boolean;

  /**
   * Id отзыва
   * @format int32
   */
  reviewId?: number;

  /** Текст */
  text?: string | null;

  /** Коллекция коментариев */
  comments?: SravniReviewsModelsExternalApiExternalApiCommentModel[] | null;
}

export interface SravniReviewsModelsExternalApiExternalApiReviewModel {
  /**
   * Дата создания
   * @format date-time
   */
  date?: string | null;

  /**
   * Оценка
   * @format int32
   */
  rate?: number | null;

  /** статус отзыва */
  status?: SravniReviewsEnumsReviewStatus;

  /** Статусы проверки оценки отзыва */
  rateStatus?: SravniReviewsEnumsReviewRateStatus;

  /**
   * Идентификатор автора
   * @format int32
   */
  authorId?: number | null;

  /** Имя автора */
  authorName?: string | null;

  /** Ответ компании */
  hasCompanyResponse?: boolean;

  /**
   * Дата решения проблемы
   * @format date-time
   */
  problemSolutionDate?: string | null;

  /** Флаг решения проблемы */
  problemSolved?: boolean;

  /** Конкретный продукт, на который сделан отзыв (Кредитная карта Tinkoff Black) */
  specificProductName?: string | null;

  /**
   * Идентификатор отзыва
   * @format int32
   */
  id?: number;

  /** Заголовок отзыва */
  title?: string | null;

  /** Текст отзыва */
  text?: string | null;

  /** Физический или юридический отзыв */
  isLegal?: boolean | null;

  /** список коментариев */
  comments?: SravniReviewsModelsExternalApiExternalApiCommentModel[] | null;
  location?: SravniReviewsLocationData;
  locationGar?: SravniReviewsLocationGarData;
  serviceTag?: SravniReviewsModelsServiceTagModel;
}

export interface SravniReviewsModelsExternalApiExternalApiReviewSortedByEventModel {
  eventType?: SravniReviewsEnumsExternalApiActivityEventType;

  /** @format date-time */
  lastModifiedDate?: string;

  /**
   * Дата создания
   * @format date-time
   */
  date?: string | null;

  /**
   * Оценка
   * @format int32
   */
  rate?: number | null;

  /** статус отзыва */
  status?: SravniReviewsEnumsReviewStatus;

  /** Статусы проверки оценки отзыва */
  rateStatus?: SravniReviewsEnumsReviewRateStatus;

  /**
   * Идентификатор автора
   * @format int32
   */
  authorId?: number | null;

  /** Имя автора */
  authorName?: string | null;

  /** Ответ компании */
  hasCompanyResponse?: boolean;

  /**
   * Дата решения проблемы
   * @format date-time
   */
  problemSolutionDate?: string | null;

  /** Флаг решения проблемы */
  problemSolved?: boolean;

  /** Конкретный продукт, на который сделан отзыв (Кредитная карта Tinkoff Black) */
  specificProductName?: string | null;

  /**
   * Идентификатор отзыва
   * @format int32
   */
  id?: number;

  /** Заголовок отзыва */
  title?: string | null;

  /** Текст отзыва */
  text?: string | null;

  /** Физический или юридический отзыв */
  isLegal?: boolean | null;

  /** список коментариев */
  comments?: SravniReviewsModelsExternalApiExternalApiCommentModel[] | null;
  location?: SravniReviewsLocationData;
  locationGar?: SravniReviewsLocationGarData;
  serviceTag?: SravniReviewsModelsServiceTagModel;
}

/**
 * Модель для отдельной ручки с передачей номера телефона и прочих персональных данных пользователя
 */
export interface SravniReviewsModelsExternalApiExternalApiReviewWithUserDataModel {
  /** Телефон пользователя */
  authorPhone?: string | null;

  /**
   * Дата создания
   * @format date-time
   */
  date?: string | null;

  /**
   * Оценка
   * @format int32
   */
  rate?: number | null;

  /** статус отзыва */
  status?: SravniReviewsEnumsReviewStatus;

  /** Статусы проверки оценки отзыва */
  rateStatus?: SravniReviewsEnumsReviewRateStatus;

  /**
   * Идентификатор автора
   * @format int32
   */
  authorId?: number | null;

  /** Имя автора */
  authorName?: string | null;

  /** Ответ компании */
  hasCompanyResponse?: boolean;

  /**
   * Дата решения проблемы
   * @format date-time
   */
  problemSolutionDate?: string | null;

  /** Флаг решения проблемы */
  problemSolved?: boolean;

  /** Конкретный продукт, на который сделан отзыв (Кредитная карта Tinkoff Black) */
  specificProductName?: string | null;

  /**
   * Идентификатор отзыва
   * @format int32
   */
  id?: number;

  /** Заголовок отзыва */
  title?: string | null;

  /** Текст отзыва */
  text?: string | null;

  /** Физический или юридический отзыв */
  isLegal?: boolean | null;

  /** список коментариев */
  comments?: SravniReviewsModelsExternalApiExternalApiCommentModel[] | null;
  location?: SravniReviewsLocationData;
  locationGar?: SravniReviewsLocationGarData;
  serviceTag?: SravniReviewsModelsServiceTagModel;
}

export interface SravniReviewsModelsExternalApiExternalApiReviewWithUserDataSortedByEventModel {
  /** Телефон пользователя */
  authorPhone?: string | null;
  eventType?: SravniReviewsEnumsExternalApiActivityEventType;

  /** @format date-time */
  lastModifiedDate?: string;

  /**
   * Дата создания
   * @format date-time
   */
  date?: string | null;

  /**
   * Оценка
   * @format int32
   */
  rate?: number | null;

  /** статус отзыва */
  status?: SravniReviewsEnumsReviewStatus;

  /** Статусы проверки оценки отзыва */
  rateStatus?: SravniReviewsEnumsReviewRateStatus;

  /**
   * Идентификатор автора
   * @format int32
   */
  authorId?: number | null;

  /** Имя автора */
  authorName?: string | null;

  /** Ответ компании */
  hasCompanyResponse?: boolean;

  /**
   * Дата решения проблемы
   * @format date-time
   */
  problemSolutionDate?: string | null;

  /** Флаг решения проблемы */
  problemSolved?: boolean;

  /** Конкретный продукт, на который сделан отзыв (Кредитная карта Tinkoff Black) */
  specificProductName?: string | null;

  /**
   * Идентификатор отзыва
   * @format int32
   */
  id?: number;

  /** Заголовок отзыва */
  title?: string | null;

  /** Текст отзыва */
  text?: string | null;

  /** Физический или юридический отзыв */
  isLegal?: boolean | null;

  /** список коментариев */
  comments?: SravniReviewsModelsExternalApiExternalApiCommentModel[] | null;
  location?: SravniReviewsLocationData;
  locationGar?: SravniReviewsLocationGarData;
  serviceTag?: SravniReviewsModelsServiceTagModel;
}

/**
 * Обобщённая модель фильтра
 */
export interface SravniReviewsModelsFiltersFilterItem {
  /** Значение key */
  key?: string | null;

  /** Значение name */
  name?: string | null;

  /** Значение alias */
  alias?: string | null;
}

/**
 * Модель с конфигурациями фильтров
 */
export interface SravniReviewsModelsFiltersFiltersModel {
  /**
   * Идентификатор
   * @format int32
   */
  id?: number;

  /** Наименование фильтра */
  name?: string | null;

  /** Алиас фильтра */
  alias?: string | null;

  /** Список услуг */
  tag?: SravniReviewsModelsFiltersFilterItem[] | null;

  /** Список оценок */
  reviewRate?: SravniReviewsModelsFiltersFilterItem[] | null;

  /** Список направлений сортировки отзывов */
  reviewOrder?: SravniReviewsModelsFiltersFilterItem[] | null;

  /** Список статусов оценки отзывов */
  rateStatus?: SravniReviewsModelsFiltersFilterItem[] | null;

  /** Фильтры для неавторизованных пользователей */
  reviewFilter?: SravniReviewsModelsFiltersFilterItem[] | null;

  /** Фильтры для авторизованных пользователей */
  reviewFullFilter?: SravniReviewsModelsFiltersFilterItem[] | null;
}

/**
 * Модель для получения хешированных данных
 */
export interface SravniReviewsModelsHashedDataHashedReviewUserDataModel {
  /** Захешированный номер телефона */
  hashedPhoneNumber?: string | null;
}

export interface SravniReviewsModelsRatingAggregatedRatingModel {
  /** @format date-time */
  created?: string;
  organizationId?: string | null;
  organizationName?: string | null;
  organizationAlias?: string | null;
  organizationType?: SravniOrganizationsSharedReviewObjectType;

  /** @format double */
  totalValue?: number;
  reviewTag?: string | null;
  specificProductId?: string | null;

  /** @format int32 */
  participantsCount?: number;

  /** @format double */
  ratingValue?: number;

  /** @format date-time */
  updated?: string | null;

  /** @format int32 */
  id?: number;
}

export interface SravniReviewsModelsRatingAggregatedRatingStatsModel {
  /** @format date-time */
  created?: string;

  /** @format int32 */
  participantsCount?: number;

  /** @format double */
  ratingValue?: number;
  tag?: string | null;
}

export interface SravniReviewsModelsRatingBackofficeRatingModel {
  serviceTagName?: string | null;

  /** @format date-span */
  responseTime?: string | null;

  /** @format date-span */
  resolvedTime?: string | null;

  /** @format int32 */
  withAnswers?: number;

  /** @format int32 */
  withoutAnswers?: number;

  /** @format int64 */
  responseTimeTicks?: number;

  /** @format int32 */
  resolved?: number;

  /** @format int32 */
  unresolved?: number;

  /** @format int64 */
  resolutionTimeTicks?: number;

  /** @format int32 */
  approved?: number;

  /** @format int32 */
  blocked?: number;

  /** @format double */
  sumRating?: number;

  /** @format double */
  sumRatingCoefficient?: number;

  /** @format double */
  individualRating?: number;

  /** @format double */
  individualRatingImportance?: number;
  locationInfo?: SravniReviewsLocationData;
  locationGarInfo?: SravniReviewsLocationGarData;
  filterInfo?: SravniReviewsFilterInfo;

  /**
   * Позиция в рейтинге
   * @format int32
   */
  position?: number;

  /**
   * Общее кол-во позиций,
   * @format int32
   */
  totalPositions?: number;
  isLegal?: boolean | null;

  /** @format double */
  complexCalculatedRatingValue?: number;

  /** @format date-time */
  created?: string;
  organizationId?: string | null;
  organizationName?: string | null;
  organizationAlias?: string | null;
  organizationType?: SravniOrganizationsSharedReviewObjectType;

  /** @format double */
  totalValue?: number;
  reviewTag?: string | null;
  specificProductId?: string | null;

  /** @format int32 */
  participantsCount?: number;

  /** @format double */
  ratingValue?: number;

  /** @format date-time */
  updated?: string | null;

  /** @format int32 */
  id?: number;
}

/**
 * Модель для рейтингов, выводящихся в ИП
 */
export interface SravniReviewsModelsRatingRatingForInterestingOffersModel {
  /** ID конкретного продукта */
  specificProductId?: string | null;

  /**
   * Конечный рассчитанный рейтинг
   * @format double
   */
  complexCalculatedRatingValue?: number;

  /**
   * Количество отзывов
   * @format int32
   */
  participantsCount?: number;
}

/**
 * Модель для создания прочитанного комментария
 */
export interface SravniReviewsModelsReadedCommentCreateOrUpdateReadedCommentModel {
  /**
   * ИТдентификатор отзыва
   * @format int32
   */
  reviewId?: number;

  /**
   * Дата прочтенного комментария
   * @format date-time
   */
  date: string;
}

/**
 * Модель для получения последнего прочитанного комментария
 */
export interface SravniReviewsModelsReadedCommentLastReadedCommentModel {
  /**
   * Идентификатор отзыва
   * @format int32
   */
  reviewId?: number;

  /**
   * Дата последнего прочтенного комментария
   * @format date-time
   */
  lastReadedDate?: string | null;
}

/**
 * Модель для получения количества непрочитанных комментариев по отзыву
 */
export interface SravniReviewsModelsReadedCommentUnreadedCommentsCountModelByReview {
  /**
   * Идентификатор отзыва
   * @format int32
   */
  reviewId?: number;

  /**
   * Количество непрочитанных комментариев
   * @format int32
   */
  count?: number;
}

export interface SravniReviewsModelsReputationReputationCompanyResponseStatsByRatingModel {
  /**
   * Оценка
   * @format int32
   */
  ratingValue?: number;

  /**
   * Общее кол-во отзывов
   * @format int32
   */
  reviewsCount?: number;

  /**
   * Отзывов с ответами
   * @format int32
   */
  answersCount?: number;

  /**
   * Доля отзывов с ответами по отношению к общему кол-ву отзывов в процентах
   * @format double
   */
  partByPercent?: number;
  avgResponseTime?: SravniReviewsModelsReputationTime;
}

export interface SravniReviewsModelsReputationReputationCompanyResponseStatsByTagModel {
  /** @format int32 */
  productTag?: number;

  /** Cтатистика, но с разбивкой на оценки */
  statsByRating?: SravniReviewsModelsReputationReputationCompanyResponseStatsByRatingModel[] | null;

  /**
   * Общее кол-во отзывов
   * @format int32
   */
  reviewsCount?: number;

  /**
   * Отзывов с ответами
   * @format int32
   */
  answersCount?: number;

  /**
   * Доля отзывов с ответами по отношению к общему кол-ву отзывов в процентах
   * @format double
   */
  partByPercent?: number;
  avgResponseTime?: SravniReviewsModelsReputationTime;
}

export interface SravniReviewsModelsReputationReputationCompanyResponseStatsModel {
  /** Такая же статистика, но с разбивкой на оценки */
  statsByRating?: SravniReviewsModelsReputationReputationCompanyResponseStatsByRatingModel[] | null;

  /** Статистика по продуктам */
  statsByProducts?: SravniReviewsModelsReputationReputationCompanyResponseStatsByTagModel[] | null;

  /**
   * Общее кол-во отзывов
   * @format int32
   */
  reviewsCount?: number;

  /**
   * Отзывов с ответами
   * @format int32
   */
  answersCount?: number;

  /**
   * Доля отзывов с ответами по отношению к общему кол-ву отзывов в процентах
   * @format double
   */
  partByPercent?: number;
  avgResponseTime?: SravniReviewsModelsReputationTime;
}

/**
 * Модель для детализации csv
 */
export interface SravniReviewsModelsReputationReputationCsvModel {
  /**
   * Наименование файла
   * @format byte
   */
  fileName?: string | null;

  /**
   * Контент
   * @format byte
   */
  content?: string | null;
}

export interface SravniReviewsModelsReputationReputationDetailByRating {
  /**
   * Оценка
   * @format int32
   */
  ratingValue?: number;

  /**
   * Количество подтвержденных отзывов
   * @format int32
   */
  approvedCount?: number;
}

export interface SravniReviewsModelsReputationReputationDetailedStatsModel {
  /**
   * Дата начала периода
   * @format date-time
   */
  from?: string;

  /**
   * Дата окончания периода
   * @format date-time
   */
  to?: string;

  /**
   * Общее кол-во отзывов
   * @format int32
   */
  reviewsCount?: number;

  /**
   * Сумма количества отзывов за предыдущие периоды
   * @format int32
   */
  totalReviewsCount?: number;

  /**
   * Отзывы на модерации
   * @format int32
   */
  onModerationCount?: number;

  /**
   * Общее кол-во позитивных отзывов
   * @format int32
   */
  totalPositiveRatingCount?: number;

  /**
   * Общее кол-во негативных отзывов
   * @format int32
   */
  totalNegativeRatingCount?: number;

  /**
   * Кол-во подтвержденных отзывов
   * @format int32
   */
  approvedCount?: number;

  /**
   * Кол-во отклоненных отзывов
   * @format int32
   */
  rejectedCount?: number;

  /**
   * Средний рейтинг на обозначенный период
   * @format double
   */
  avgRatingValue?: number;

  /**
   * Кол-во отзывов с ответом организации
   * @format int32
   */
  answersCount?: number;

  /**
   * Кол-во решенных проблем
   * @format int32
   */
  resolvedCount?: number;
  avgResponseTime?: SravniReviewsModelsReputationTime;
  avgResolvedTime?: SravniReviewsModelsReputationTime;

  /**
   * Кол-во лайков
   * @format int32
   */
  positiveVotesCount?: number;

  /**
   * Кол-во дизлайков
   * @format int32
   */
  negativeVotesCount?: number;

  /**
   * Кол-во позитивных отзывов
   * @format int32
   */
  positiveRatingCount?: number;

  /**
   * Кол-во негативных отзывов
   * @format int32
   */
  negativeRatingCount?: number;

  /** Статистика по оценкам */
  ratingStats?: SravniReviewsModelsReputationReputationDetailByRating[] | null;
}

/**
 * Статистика по локациям
 */
export interface SravniReviewsModelsReputationReputationLocationStats {
  /**
   * Идентификатор локации
   * @format int32
   */
  id?: number;

  /**
   * Идентификатор локации (новый формат)
   * @format int32
   */
  garId?: number;
  name?: string | null;
  nameLocative?: string | null;

  /**
   * Оценка рейтинга
   * @format double
   */
  avgRatingValue?: number;

  /**
   * Кол-во подтвержденных оценок
   * @format int32
   */
  approvedReviewsCount?: number;

  /** @format double */
  latitude?: number | null;

  /** @format double */
  longitude?: number | null;
}

export interface SravniReviewsModelsReputationReputationPerformanceOverviewModel {
  statsByRating?: SravniReviewsModelsReputationReputationPerformanceOverviewPartModel[] | null;

  /**
   * Процент прироста в сравнении с прошлым периодом
   * @format double
   */
  increasePercent?: number;

  /**
   * Кол-во подтвержденных оценок
   * @format int32
   */
  approvedCount?: number;
}

export interface SravniReviewsModelsReputationReputationPerformanceOverviewPartModel {
  /**
   * Значение оценки
   * @format int32
   */
  ratingValue?: number;

  /**
   * Доля от общего кол-ва подтвержденных отзывов
   * @format double
   */
  partPercent?: number;

  /**
   * Кол-во подтвержденных оценок
   * @format int32
   */
  approvedCount?: number;
}

export interface SravniReviewsModelsReputationReputationPositionByDayModel {
  /**
   * Дата
   * @format date-time
   */
  date?: string;

  /**
   * Позиция
   * @format int32
   */
  postision?: number;

  /**
   * Всего компаний
   * @format int32
   */
  total?: number;
}

export interface SravniReviewsModelsReputationReputationPositionModel {
  /**
   * Позиция в топе по клиентскому рейтингу
   * @format int32
   */
  position?: number;

  /**
   * Всего позиций в клиентском рейтинге
   * @format int32
   */
  total?: number;

  /**
   * Значение рейтинга
   * @format double
   */
  bayesRating?: number;

  /** История изменения рейтинга */
  ratingTrendLine?: SravniReviewsModelsReputationReputationPositionByDayModel[] | null;
}

export interface SravniReviewsModelsReputationReputationRatingByLastMonth {
  /**
   * Если true = весь период;
   * Если false - последние 3 месяца
   */
  fullPeriod?: boolean;

  /**
   * Значение рейтинга
   * @format double
   */
  ratingValue?: number;

  /**
   * Кол-во подтвержденных отзывов
   * @format int32
   */
  approvedCount?: number;

  /**
   * Кол-во отзывов, аппрувнутых модераторами
   * @format int32
   */
  checkedCount?: number;

  /**
   * Кол-во отзывов, в целом видимых пользователям
   * @format int32
   */
  participantsCount?: number;

  /**
   * Кол-во отзывов с решённой  проблемой
   * @format int32
   */
  problemSolvedCount?: number;
}

export interface SravniReviewsModelsReputationReputationRatingCountedStats {
  /** @format int32 */
  ratingValue?: number;

  /** @format int32 */
  reviewsCount?: number;

  /** @format int32 */
  approvedCount?: number;

  /** @format int32 */
  rejectedCount?: number;
}

/**
 * Статистика по оценкам
 */
export interface SravniReviewsModelsReputationReputationRatingPeriodStats {
  /** @format date-time */
  from?: string;

  /** @format date-time */
  to?: string;

  /** @format int32 */
  totalApprovedCount?: number;

  /** @format int32 */
  reviewsCount?: number;

  /** @format int32 */
  onModerationReviewsCount?: number;
  ratingCountedStats?: SravniReviewsModelsReputationReputationRatingCountedStats[] | null;
}

/**
 * Рейтинги с разбивкой по продуктам
 */
export interface SravniReviewsModelsReputationReputationResponse {
  /** Идентификатор организации */
  organizationId?: string | null;

  /** Данные рейтинга */
  ratingStats?: SravniReviewsModelsReputationReviewsRatingModel[] | null;
}

/**
 * Контракт ответа для контроллера управленя репутацией
 */
export interface SravniReviewsModelsReputationReputationStatsModel {
  organizationId?: string | null;
  productTag?: string | null;
  groupedType?: SravniReviewsEnumsReputationGroupingType;

  /** @format double */
  avgRatingValue?: number;

  /** @format int32 */
  approvedReviewsCount?: number;

  /** @format int32 */
  reviewsCount?: number;
  statsByLocations?: SravniReviewsModelsReputationReputationLocationStats[] | null;
  statByPeriods?: SravniReviewsModelsReputationReputationRatingPeriodStats[] | null;
}

export interface SravniReviewsModelsReputationReviewsRatingModel {
  productTag?: string | null;

  /** @format int32 */
  approvedCount?: number;

  /** @format double */
  ratingValue?: number;
}

export interface SravniReviewsModelsReputationTime {
  /** @format int32 */
  milliseconds?: number;

  /** @format int32 */
  seconds?: number;

  /** @format int32 */
  minutes?: number;

  /** @format int32 */
  hours?: number;

  /** @format int32 */
  days?: number;
}

export interface SravniReviewsModelsReviewBackofficeReviewCommentListItemModel {
  /** Ip */
  ip?: string | null;

  /** FingerPrint */
  fingerPrint?: string | null;

  /** Email */
  authorEmail?: string | null;

  /** Тел */
  authorPhone?: string | null;

  /** Тел форматированный */
  authorPhoneFormatted?: string | null;

  /** В блоке/нет */
  isBlocked?: boolean;
  reviewObjectType?: SravniOrganizationsSharedReviewObjectType;

  /**
   * Тип объекта отзыва
   * @format int32
   */
  reviewTag?: number;

  /** Id объекта отзыва */
  reviewObjectId?: string | null;

  /** @format int32 */
  rootId?: number;
  rootTitle?: string | null;

  /** статус отзыва */
  reviewStatus?: SravniReviewsEnumsReviewStatus;
  reviewStatusName?: string | null;

  /** Последняя операция: наименование */
  lastModificationTypeName?: string | null;

  /** Последняя операция: пользователь */
  lastModifiedBy?: string | null;

  /**
   * Дата последней операции
   * @format date-time
   */
  lastModificationDate?: string | null;

  /**
   * ID автора
   * @format int32
   */
  userId?: number;

  /** автор */
  authorName?: string | null;

  /** Фамилия автора */
  authorLastName?: string | null;

  /** Роль */
  authorRole?: string | null;

  /** Описание роли */
  authorRoleDescription?: string | null;

  /**
   * Дата
   * @format date-time
   */
  date?: string;

  /**
   * Число комментариев
   * @format int32
   */
  commentsCount?: number;
  canDelete?: boolean;
  canEdit?: boolean;
  canEditIsMain?: boolean;
  moderationReasons?: SravniReviewsEnumsModerationReasonType[] | null;

  /** Признак того что автор был удалён */
  isAuthorDeleted?: boolean;

  /**
   * Id
   * @format int32
   */
  id?: number;

  /**
   * Id комментария родителя
   * @format int32
   */
  parentId?: number | null;

  /**
   * Id отзыва
   * @format int32
   * @min 1
   * @max 2147483647
   */
  reviewId: number;

  /** Текст */
  text: string;

  /** Является ли ответ главным или нет */
  isMain?: boolean;
}

export interface SravniReviewsModelsReviewBackofficeReviewListItemModel {
  authorPhone?: string | null;

  /** Тел форматированный */
  authorPhoneFormatted?: string | null;

  /** Информация для организации, видна только пользователю, пред. организации, модератору и админу */
  messageForCompany?: string | null;
  reviewUserData?: SravniReviewsModelsReviewReviewUserDataModel;

  /** Email пользователя */
  authorEmail?: string | null;
  utm?: SravniReviewsUtm;

  /**
   * ID отзыва (для комментов)
   * @format int32
   */
  rootId?: number | null;

  /** Тема отзыва (для комментов) */
  rootTitle?: string | null;

  /** Ip */
  ip?: string | null;

  /** статус отзыва */
  reviewStatus?: SravniReviewsEnumsReviewStatus;

  /** На контроле */
  followUp?: boolean;

  /** Мыло контроллирующего модератора */
  moderatorEmail?: string | null;

  /** Последняя операция: наименование */
  lastModificationTypeName?: string | null;

  /** Последняя операция: пользователь */
  lastModifiedBy?: string | null;

  /**
   * Дата последней операции
   * @format date-time
   */
  lastModificationDate?: string | null;
  fingerPrint?: string | null;
  checked?: boolean;
  hasCompanyRepresentative?: boolean;
  deleted?: boolean;

  /** @format date-time */
  deleteDate?: string | null;
  isBlocked?: boolean;

  /**
   * Дата вывода на контроль
   * @format date-time
   */
  followUpDate?: string | null;

  /** @format int32 */
  followUpDaysCount?: number;
  reviewNote?: SravniReviewsModelsReviewReviewNoteModel;

  /** Является клиентом сравни */
  isSravniClient?: boolean;

  /** Модель для получения хешированных данных */
  hashedUserDataModel?: SravniReviewsModelsHashedDataHashedReviewUserDataModel;

  /**
   * кол-во комментариев
   * @format int32
   */
  commentsCount?: number;

  /**
   * Id отзыва
   * @format int32
   */
  id?: number;

  /**
   * Id пользователя
   * @format int32
   */
  userId?: number | null;

  /**
   * Дата отзыва
   * @format date-time
   */
  date?: string;

  /**
   * Id города отзыва
   * @format int32
   */
  locationId?: number;

  /**
   * Id города отзыва (новый формат)
   * @format int32
   */
  locationGarId?: number;

  /** заголовок */
  title: string;

  /** Текст */
  text: string;

  /** О какой компании отзыв */
  reviewObjectId?: string | null;
  reviewObjectType?: SravniOrganizationsSharedReviewObjectType;

  /** Тема отзыва */
  reviewTag?: string | null;

  /** Физический или юридический отзыв */
  isLegal?: boolean | null;

  /**
   * Базовая оценка, которую может менять пользователь или модератор
   * @format int32
   */
  ratingBase?: number | null;

  /** ID конкретного продукта */
  specificProductId?: string | null;

  /** Имя конкретного продукта */
  specificProductName?: string | null;

  /** Дополнительная информация */
  additionalJsonData?: string | null;

  /** Настройки отображения полей дополнительной информации */
  additionalInfoUiConfiguration?: string | null;

  /**
   * Идентификатор схемы дополнительной информации
   * @format int32
   */
  schemeTemplateId?: number;

  /** псевдоним автора */
  authorName?: string | null;

  /** фамилия автора */
  authorLastName?: string | null;

  /** роль автора отзыва */
  authorRole?: string | null;

  /** Описание роли */
  authorRoleDescription?: string | null;

  /** Признак того что автор был удалён */
  isAuthorDeleted?: boolean;

  /**
   * оценка
   * @format int32
   */
  rating?: number | null;

  /** Статусы проверки оценки отзыва */
  ratingStatus?: SravniReviewsEnumsReviewRateStatus;

  /** проблема решена */
  problemSolved?: boolean;
  userDataStatus?: SravniReviewsEnumsUserDataStatus;

  /**
   * Дата решения вопроса"
   * @format date-time
   */
  problemSolutionDate?: string | null;

  /**
   * Признак того что отзыв можно редактировать
   * под текущим пользователем
   */
  canEditReview?: boolean;

  /**
   * Признак того что отзыв можно удалить
   * под текущим пользователем
   */
  canDelete?: boolean;

  /**
   * Признак того что проблему можно решать
   * под текущим пользователем
   */
  canResolve?: boolean;

  /**
   * Признак того что можно редактировать скрытые поля
   * под текущим пользователем
   */
  canEditReviewHiddenFields?: boolean;

  /** Отзыв внешний (спаршенный и импортированный) */
  isExternal?: boolean;

  /** Идентификатор внешнего источника */
  externalId?: string | null;

  /** Внешний источник, откуда был взят отзыв */
  externalSource?: string | null;

  /** Ссылка на внешний источник, откуда был взят отзыв */
  externalUrl?: string | null;
  votes?: SravniReviewsModelsReviewVoteSummaryReadModel;

  /** Голос текущего пользователя */
  vote?: boolean | null;

  /** Признак того что отзыв был рекомендован пользователем */
  isRecommendedByUser?: boolean | null;

  /** Причины модерации отзыва */
  moderationReasons?: SravniReviewsEnumsModerationReasonType[] | null;

  /** Список позитивных тегов */
  positiveTags?: SravniReviewsTagModel[] | null;

  /** Список негативных тегов */
  negativeTags?: SravniReviewsTagModel[] | null;

  /** Требуется доп инфо */
  requireUserData?: boolean;
  locationData?: SravniReviewsLocationData;
  locationGarData?: SravniReviewsLocationGarData;

  /** Наличие официального ответа компании */
  hasCompanyResponse?: boolean;

  /** Отзыв о сервисе Сравни.ру */
  isAboutSravni?: boolean;
}

export interface SravniReviewsModelsReviewBackofficeReviewsReportItemModel {
  link?: string | null;
  linkFromBackoffice?: string | null;

  /**
   * Дата отзыва
   * @format date-time
   */
  created?: string;

  /** Id города отзыва */
  location?: string | null;

  /** Gar города отзыва */
  locationGar?: string | null;

  /** О какой компании отзыв */
  organizationName?: string | null;

  /** Тема отзыва */
  reviewTag?: string | null;
  status?: string | null;

  /** @format int32 */
  rating?: number;
  ratingStatus?: string | null;
  hasCompanyResponse?: string | null;
  isAboutSravni?: string | null;
  answeredBy?: string | null;
  authorPhone?: string | null;
  ip?: string | null;
  fingerPrint?: string | null;
  userNameForAppeal?: string | null;
  authorEmail?: string | null;
  userPhoneForAppeal?: string | null;

  /** @format date-time */
  userBirthDateForAppeal?: string | null;
  isAuthorDeleted?: string | null;

  /** @format int32 */
  rewiewsCountByAuthor?: number | null;
  messageForCompany?: string | null;
  text?: string | null;
  isLegal?: string | null;
  note?: string | null;
  utmSource?: string | null;
  utmCampaign?: string | null;
  utmMedium?: string | null;

  /** @format date-time */
  deleteDate?: string | null;
  deleteReason?: string | null;
}

export interface SravniReviewsModelsReviewCommentCheckModel {
  /**
   * Id комментария
   * @format int32
   * @min 1
   * @max 2147483647
   */
  commentId?: number;

  /** проверен/не проверен */
  checked?: boolean;
}

export interface SravniReviewsModelsReviewExcelImportModel {
  /** @format byte */
  file: string;
  reviewTag: string;
  organizationType: SravniOrganizationsSharedOrganizationType;

  /** Статусы проверки оценки отзыва */
  reviewRateStatus?: SravniReviewsEnumsReviewRateStatus;
  requireModeration?: boolean;
  setAllAsChecked?: boolean;
}

export interface SravniReviewsModelsReviewProductTagsCountModel {
  serviceTagCode?: string | null;
  serviceTagName?: string | null;
  serviceTagAlias?: string | null;
  positiveTags?: SravniReviewsModelsReviewTagsCountModel[] | null;
  negativeTags?: SravniReviewsModelsReviewTagsCountModel[] | null;
}

export interface SravniReviewsModelsReviewRatingApprovalModel {
  /**
   * Id отзыва
   * @format int32
   * @min 1
   * @max 2147483647
   */
  reviewId?: number;

  /** Одобрен/запрещен/еще не проверен */
  approved?: boolean | null;

  /**
   * Новая оценка
   * @format int32
   */
  rating?: number;
}

export interface SravniReviewsModelsReviewRawReviewCountModel {
  organizationName?: string | null;

  /** @format int32 */
  checkingReviewCount?: number;

  /** @format int32 */
  checkingNotConfirmedReviewCount?: number;

  /** @format date-time */
  firstCheckingReview?: string | null;

  /** @format date-time */
  firstCheckingNotConfirmedReview?: string | null;
}

export interface SravniReviewsModelsReviewResolveReviewModel {
  /** @format int32 */
  id?: number;
  problemSolved?: boolean | null;
}

export interface SravniReviewsModelsReviewReviewAdditionalInfoSchemeReadModel {
  organizationId?: string | null;
  organizationType?: SravniOrganizationsSharedReviewObjectType;
  serviceTag?: string | null;
  uiConfiguration?: string | null;

  /** @format int32 */
  id?: number;
  deleted?: boolean;

  /** @format date-time */
  deleteDate?: string | null;
  isPublic?: boolean;
}

export interface SravniReviewsModelsReviewReviewAdditionalInfoSchemeUpdateModel {
  organizationId?: string | null;
  organizationType?: SravniOrganizationsSharedReviewObjectType;
  productTag?: string | null;
  configuration?: string | null;
}

export interface SravniReviewsModelsReviewReviewCheckModel {
  /**
   * Id отзыва
   * @format int32
   * @min 1
   * @max 2147483647
   */
  reviewId?: number;

  /** проверен/не проверен */
  checked?: boolean;
}

/**
 * Модель для списка комментариев на чтение
 */
export interface SravniReviewsModelsReviewReviewCommentReadModel {
  /**
   * ID автора
   * @format int32
   */
  userId?: number;

  /** автор */
  authorName?: string | null;

  /** Фамилия автора */
  authorLastName?: string | null;

  /** Роль */
  authorRole?: string | null;

  /** Описание роли */
  authorRoleDescription?: string | null;

  /**
   * Дата
   * @format date-time
   */
  date?: string;

  /**
   * Число комментариев
   * @format int32
   */
  commentsCount?: number;
  canDelete?: boolean;
  canEdit?: boolean;
  canEditIsMain?: boolean;
  moderationReasons?: SravniReviewsEnumsModerationReasonType[] | null;

  /** Признак того что автор был удалён */
  isAuthorDeleted?: boolean;

  /**
   * Id
   * @format int32
   */
  id?: number;

  /**
   * Id комментария родителя
   * @format int32
   */
  parentId?: number | null;

  /**
   * Id отзыва
   * @format int32
   * @min 1
   * @max 2147483647
   */
  reviewId: number;

  /** Текст */
  text: string;

  /** Является ли ответ главным или нет */
  isMain?: boolean;
}

/**
 * Модель для редактирования комментария
 */
export interface SravniReviewsModelsReviewReviewCommentUpdateModel {
  utm?: SravniReviewsUtm;

  /** FingerPrint (для поиска спамеров) */
  fingerPrint: string;

  /** Ip адрес (для поиска спамеров) */
  ip: string;

  /** UserAgent (для поиска спамеров) */
  userAgent?: string | null;

  /**
   * Идентификатор локации нового формата
   * @format int32
   */
  authorLocationId?: number;

  /**
   * Идентификатор локации старого формата
   * @format int32
   */
  locationGarId?: number;

  /**
   * Id
   * @format int32
   */
  id?: number;

  /**
   * Id комментария родителя
   * @format int32
   */
  parentId?: number | null;

  /**
   * Id отзыва
   * @format int32
   * @min 1
   * @max 2147483647
   */
  reviewId: number;

  /** Текст */
  text: string;

  /** Является ли ответ главным или нет */
  isMain?: boolean;
}

export interface SravniReviewsModelsReviewReviewCompanyResponseModel {
  /**
   * Id отзыва
   * @format int32
   * @min 1
   * @max 2147483647
   */
  reviewId?: number;

  /** есть/нет официальный ответ */
  hasCompanyResponse?: boolean;
}

/**
 * модель отзыва для списка
 */
export interface SravniReviewsModelsReviewReviewListItemModel {
  /**
   * кол-во комментариев
   * @format int32
   */
  commentsCount?: number;

  /**
   * Id отзыва
   * @format int32
   */
  id?: number;

  /**
   * Id пользователя
   * @format int32
   */
  userId?: number | null;

  /**
   * Дата отзыва
   * @format date-time
   */
  date?: string;

  /**
   * Id города отзыва
   * @format int32
   */
  locationId?: number;

  /**
   * Id города отзыва (новый формат)
   * @format int32
   */
  locationGarId?: number;

  /** заголовок */
  title: string;

  /** Текст */
  text: string;

  /** О какой компании отзыв */
  reviewObjectId?: string | null;
  reviewObjectType?: SravniOrganizationsSharedReviewObjectType;

  /** Тема отзыва */
  reviewTag?: string | null;

  /** Физический или юридический отзыв */
  isLegal?: boolean | null;

  /**
   * Базовая оценка, которую может менять пользователь или модератор
   * @format int32
   */
  ratingBase?: number | null;

  /** ID конкретного продукта */
  specificProductId?: string | null;

  /** Имя конкретного продукта */
  specificProductName?: string | null;

  /** Дополнительная информация */
  additionalJsonData?: string | null;

  /** Настройки отображения полей дополнительной информации */
  additionalInfoUiConfiguration?: string | null;

  /**
   * Идентификатор схемы дополнительной информации
   * @format int32
   */
  schemeTemplateId?: number;

  /** псевдоним автора */
  authorName?: string | null;

  /** фамилия автора */
  authorLastName?: string | null;

  /** роль автора отзыва */
  authorRole?: string | null;

  /** Описание роли */
  authorRoleDescription?: string | null;

  /** Признак того что автор был удалён */
  isAuthorDeleted?: boolean;

  /**
   * оценка
   * @format int32
   */
  rating?: number | null;

  /** Статусы проверки оценки отзыва */
  ratingStatus?: SravniReviewsEnumsReviewRateStatus;

  /** проблема решена */
  problemSolved?: boolean;
  userDataStatus?: SravniReviewsEnumsUserDataStatus;

  /**
   * Дата решения вопроса"
   * @format date-time
   */
  problemSolutionDate?: string | null;

  /**
   * Признак того что отзыв можно редактировать
   * под текущим пользователем
   */
  canEditReview?: boolean;

  /**
   * Признак того что отзыв можно удалить
   * под текущим пользователем
   */
  canDelete?: boolean;

  /**
   * Признак того что проблему можно решать
   * под текущим пользователем
   */
  canResolve?: boolean;

  /**
   * Признак того что можно редактировать скрытые поля
   * под текущим пользователем
   */
  canEditReviewHiddenFields?: boolean;

  /** Отзыв внешний (спаршенный и импортированный) */
  isExternal?: boolean;

  /** Идентификатор внешнего источника */
  externalId?: string | null;

  /** Внешний источник, откуда был взят отзыв */
  externalSource?: string | null;

  /** Ссылка на внешний источник, откуда был взят отзыв */
  externalUrl?: string | null;

  /** Признак того что текущий пользователь был заблокирован */
  isBlocked?: boolean;
  votes?: SravniReviewsModelsReviewVoteSummaryReadModel;

  /** Голос текущего пользователя */
  vote?: boolean | null;

  /** Признак того что отзыв был рекомендован пользователем */
  isRecommendedByUser?: boolean | null;

  /** Причины модерации отзыва */
  moderationReasons?: SravniReviewsEnumsModerationReasonType[] | null;

  /** Список позитивных тегов */
  positiveTags?: SravniReviewsTagModel[] | null;

  /** Список негативных тегов */
  negativeTags?: SravniReviewsTagModel[] | null;

  /** Признак того что отзыв был оставлен клиентом Сравни */
  isSravniClient?: boolean | null;

  /** Требуется доп инфо */
  requireUserData?: boolean;
  locationData?: SravniReviewsLocationData;
  locationGarData?: SravniReviewsLocationGarData;

  /** Признак удаления */
  deleted?: boolean;

  /** Наличие официального ответа компании */
  hasCompanyResponse?: boolean;

  /** Отзыв о сервисе Сравни.ру */
  isAboutSravni?: boolean;
}

export interface SravniReviewsModelsReviewReviewNoteModel {
  /** @format int32 */
  reviewId?: number;
  text?: string | null;

  /** Причина удаления отзыва */
  deleteReason?: SravniReviewsEnumsDeleteReason;
}

/**
 * Валидируемая модель обновления данных пользователя для отзыва
 */
export interface SravniReviewsModelsReviewReviewPersonalDataValidatableModel {
  /** О какой компании отзыв */
  reviewObjectId?: string | null;

  /**
   * Id отзыва
   * @format int32
   */
  id?: number;

  /** Дополнительная информация */
  additionalJsonData?: string | null;

  /** Настройки отображения полей дополнительной информации */
  additionalInfoUiConfiguration?: string | null;

  /**
   * Идентификатор схемы дополнительной информации
   * @format int32
   */
  schemeTemplateId?: number;

  /** Информация для организации, видна только пользователю, пред. организации, модератору и админу */
  messageForCompany?: string | null;

  /**
   * Приложенные файлы или документы
   * На текущий момент нет ограничений
   */
  attachments?: string[] | null;
  reviewUserData?: SravniReviewsModelsReviewReviewUserDataModel;
}

/**
 * Модель отзыва с данными пользователя
 */
export interface SravniReviewsModelsReviewReviewReadModelWithUserData {
  /** Email пользователя */
  authorEmail?: string | null;

  /** Тел */
  authorPhone?: string | null;

  /** Тел форматированный */
  authorPhoneFormatted?: string | null;

  /** статус отзыва */
  reviewStatus?: SravniReviewsEnumsReviewStatus;

  /** На контроле */
  followUp?: boolean;

  /** Айпишник пользователя */
  ip?: string | null;

  /** Фингерпринт пользователя */
  fingerPrint?: string | null;

  /** Юзерагент пользователя */
  userAgent?: string | null;
  utm?: SravniReviewsUtm;
  reviewUserData?: SravniReviewsModelsReviewReviewUserDataModel;

  /** Информация для организации, видна только пользователю, пред. организации, модератору и админу */
  messageForCompany?: string | null;

  /** Коллекция с приложенными файлами */
  attachments?: string[] | null;

  /**
   * Id отзыва
   * @format int32
   */
  id?: number;

  /**
   * Id пользователя
   * @format int32
   */
  userId?: number | null;

  /**
   * Дата отзыва
   * @format date-time
   */
  date?: string;

  /**
   * Id города отзыва
   * @format int32
   */
  locationId?: number;

  /**
   * Id города отзыва (новый формат)
   * @format int32
   */
  locationGarId?: number;

  /** заголовок */
  title: string;

  /** Текст */
  text: string;

  /** О какой компании отзыв */
  reviewObjectId?: string | null;
  reviewObjectType?: SravniOrganizationsSharedReviewObjectType;

  /** Тема отзыва */
  reviewTag?: string | null;

  /** Физический или юридический отзыв */
  isLegal?: boolean | null;

  /**
   * Базовая оценка, которую может менять пользователь или модератор
   * @format int32
   */
  ratingBase?: number | null;

  /** ID конкретного продукта */
  specificProductId?: string | null;

  /** Имя конкретного продукта */
  specificProductName?: string | null;

  /** Дополнительная информация */
  additionalJsonData?: string | null;

  /** Настройки отображения полей дополнительной информации */
  additionalInfoUiConfiguration?: string | null;

  /**
   * Идентификатор схемы дополнительной информации
   * @format int32
   */
  schemeTemplateId?: number;

  /** псевдоним автора */
  authorName?: string | null;

  /** фамилия автора */
  authorLastName?: string | null;

  /** роль автора отзыва */
  authorRole?: string | null;

  /** Описание роли */
  authorRoleDescription?: string | null;

  /** Признак того что автор был удалён */
  isAuthorDeleted?: boolean;

  /**
   * оценка
   * @format int32
   */
  rating?: number | null;

  /** Статусы проверки оценки отзыва */
  ratingStatus?: SravniReviewsEnumsReviewRateStatus;

  /** проблема решена */
  problemSolved?: boolean;
  userDataStatus?: SravniReviewsEnumsUserDataStatus;

  /**
   * Дата решения вопроса"
   * @format date-time
   */
  problemSolutionDate?: string | null;

  /**
   * Признак того что отзыв можно редактировать
   * под текущим пользователем
   */
  canEditReview?: boolean;

  /**
   * Признак того что отзыв можно удалить
   * под текущим пользователем
   */
  canDelete?: boolean;

  /**
   * Признак того что проблему можно решать
   * под текущим пользователем
   */
  canResolve?: boolean;

  /**
   * Признак того что можно редактировать скрытые поля
   * под текущим пользователем
   */
  canEditReviewHiddenFields?: boolean;

  /** Отзыв внешний (спаршенный и импортированный) */
  isExternal?: boolean;

  /** Идентификатор внешнего источника */
  externalId?: string | null;

  /** Внешний источник, откуда был взят отзыв */
  externalSource?: string | null;

  /** Ссылка на внешний источник, откуда был взят отзыв */
  externalUrl?: string | null;

  /** Признак того что текущий пользователь был заблокирован */
  isBlocked?: boolean;
  votes?: SravniReviewsModelsReviewVoteSummaryReadModel;

  /** Голос текущего пользователя */
  vote?: boolean | null;

  /** Признак того что отзыв был рекомендован пользователем */
  isRecommendedByUser?: boolean | null;

  /** Причины модерации отзыва */
  moderationReasons?: SravniReviewsEnumsModerationReasonType[] | null;

  /** Список позитивных тегов */
  positiveTags?: SravniReviewsTagModel[] | null;

  /** Список негативных тегов */
  negativeTags?: SravniReviewsTagModel[] | null;

  /**
   * Количество комментариев
   * @format int32
   */
  commentsCount?: number;

  /** Признак того что отзыв был оставлен клиентом Сравни */
  isSravniClient?: boolean | null;

  /** Требуется доп инфо */
  requireUserData?: boolean;
  locationData?: SravniReviewsLocationData;
  locationGarData?: SravniReviewsLocationGarData;

  /** Признак удаления */
  deleted?: boolean;

  /** Наличие официального ответа компании */
  hasCompanyResponse?: boolean;

  /** Отзыв о сервисе Сравни.ру */
  isAboutSravni?: boolean;
}

export interface SravniReviewsModelsReviewReviewTagsCountModel {
  organizationId?: string | null;
  organizationType?: SravniOrganizationsSharedReviewObjectType;

  /** @format date-time */
  from?: string;

  /** @format date-time */
  to?: string;
  productTags?: SravniReviewsModelsReviewProductTagsCountModel[] | null;
}

export interface SravniReviewsModelsReviewReviewUpdateValidatableModel {
  utm?: SravniReviewsUtm;

  /** FingerPrint (для поиска спамеров) */
  fingerPrint: string;

  /** Ip адрес (для поиска спамеров) */
  ip: string;

  /** UserAgent (для поиска спамеров) */
  userAgent?: string | null;

  /** Рекомендует ли пользователь организацию */
  isRecommendedByUser?: boolean | null;

  /** Позитивные теги */
  positiveTags?: number[] | null;

  /** Негативные теги */
  negativeTags?: number[] | null;

  /** Отзыв о сервисе Сравни.ру */
  isAboutSravni?: boolean;

  /**
   * Id города отзыва
   * @format int32
   */
  locationId?: number;

  /**
   * Id города отзыва (новый формат)
   * @format int32
   */
  locationGarId?: number;

  /** заголовок */
  title: string;

  /** Текст */
  text: string;
  reviewObjectType?: SravniOrganizationsSharedReviewObjectType;

  /** Тема отзыва */
  reviewTag?: string | null;

  /** Физический или юридический отзыв */
  isLegal?: boolean | null;

  /**
   * Оценка отзыва
   * @format int32
   */
  rating?: number | null;

  /**
   * Базовая оценка, которую может менять пользователь или модератор
   * @format int32
   */
  ratingBase?: number | null;

  /** ID конкретного продукта */
  specificProductId?: string | null;

  /** Имя конкретного продукта */
  specificProductName?: string | null;

  /** О какой компании отзыв */
  reviewObjectId?: string | null;

  /**
   * Id отзыва
   * @format int32
   */
  id?: number;

  /** Дополнительная информация */
  additionalJsonData?: string | null;

  /** Настройки отображения полей дополнительной информации */
  additionalInfoUiConfiguration?: string | null;

  /**
   * Идентификатор схемы дополнительной информации
   * @format int32
   */
  schemeTemplateId?: number;

  /** Информация для организации, видна только пользователю, пред. организации, модератору и админу */
  messageForCompany?: string | null;

  /**
   * Приложенные файлы или документы
   * На текущий момент нет ограничений
   */
  attachments?: string[] | null;
  reviewUserData?: SravniReviewsModelsReviewReviewUserDataModel;
}

export interface SravniReviewsModelsReviewReviewUserDataModel {
  additionalInfo?: string | null;

  /** @format date-time */
  userBirthDateForAppeal?: string | null;
  userNameForAppeal?: string | null;
  userPhoneForAppeal?: string | null;
  isApproved?: boolean | null;

  /** @format date-time */
  registrationDate?: string | null;

  /** @format int32 */
  reviewsCount?: number | null;
  isEmpty?: boolean;
}

export interface SravniReviewsModelsReviewReviewsCountByOrganizationModel {
  /** Айдишник организации */
  organizationId?: string | null;
  organizationType?: SravniOrganizationsSharedReviewObjectType;

  /**
   * Количество отзывов, разрешённых к публикации
   * @format int32
   */
  reviewsCount?: number;
}

/**
 * Модель, аггрегирующая оценки в отзывах
 */
export interface SravniReviewsModelsReviewReviewsCountModel {
  /**
   * Идентификатор
   * @format int32
   */
  id?: number;

  /** Айдишник организации */
  organizationId?: string | null;
  organizationType?: SravniOrganizationsSharedReviewObjectType;

  /** Услуга */
  serviceTag?: string | null;

  /** Конкретный продукт */
  specificProductId?: string | null;

  /**
   * Значение оценки, на момент выкатки от 1 до 5, можно расширять как угодно
   * @format int32
   */
  ratingValue?: number | null;

  /**
   * Идентификатор региона
   * @format int32
   */
  locationId?: number | null;

  /**
   * Идентификатор региона (новый формат)
   * @format int32
   */
  locationGarId?: number | null;

  /**
   * Количество отзывов с подтвержденной оценкой
   * @format int32
   */
  reviewCount?: number;
}

/**
 * Модель агрегирующая кол-во отзывов в разрезах: организация - услуга и организация - оценка рейтинга
 */
export interface SravniReviewsModelsReviewReviewsCountReadModel {
  /** Группировка по услугам */
  groupedByServices?: SravniReviewsModelsReviewReviewsCountModel[] | null;

  /** Группировка по оценкам */
  groupedByRatingValue?: SravniReviewsModelsReviewReviewsCountModel[] | null;
}

export interface SravniReviewsModelsReviewTagsCountModel {
  name?: string | null;
  description?: string | null;
  title?: string | null;

  /** @format int32 */
  count?: number;
}

/**
 * Модель для обновления информации о заметках к отзыву
 */
export interface SravniReviewsModelsReviewUpdateReviewNoteModel {
  /** Текст заметки */
  text?: string | null;

  /** Причина удаления отзыва */
  deleteReason?: SravniReviewsEnumsDeleteReason;
}

export interface SravniReviewsModelsReviewUserContentReadModel {
  /**
   * Id
   * @format int32
   */
  id?: number;

  /**
   * Дата
   * @format date-time
   */
  date?: string;

  /** Наименование типа контента(отзыв,комментарий) */
  contentType?: string | null;

  /** Текст */
  text?: string | null;

  /** Заголовок */
  title?: string | null;
  subjectType?: SravniOrganizationsSharedReviewObjectType;

  /** Id Объект */
  subjectId?: string | null;

  /** Причины модерации */
  moderationReasons?: SravniReviewsEnumsModerationReasonType[] | null;

  /** Иконка компании на которую делается отзыв */
  icon?: string | null;

  /** Алиас орг-ии о которой отзыв */
  organizationAlias?: string | null;

  /**
   * Идентификатор отзыва
   * @format int32
   */
  reviewId?: number;
}

/**
 * Модель запроса удаления лайка
 */
export interface SravniReviewsModelsReviewVoteDeleteModel {
  /**
   * Id отзыва
   * @format int32
   * @min 1
   * @max 2147483647
   */
  reviewId: number;

  /** FingerPrint, используется если пользователь не авторизован */
  fingerPrint?: string | null;
}

export interface SravniReviewsModelsReviewVoteSummaryReadModel {
  /**
   * Положительных
   * @format int32
   */
  positive?: number;

  /**
   * Итрицательных
   * @format int32
   */
  negative?: number;
}

/**
 * Модель обновления лайка
 */
export interface SravniReviewsModelsReviewVoteUpdateModel {
  /**
   * Id отзыва
   * @format int32
   * @min 1
   * @max 2147483647
   */
  reviewId: number;

  /** Положительный: да/нет */
  positive?: boolean;

  /** FingerPrint, добавляет лайк по нему если пользователь не авторизован */
  fingerPrint?: string | null;
}

/**
 * Модель создания запроса на оставление отзыва
 */
export interface SravniReviewsModelsReviewRequestReviewRequestCreateModel {
  /**
   * Пользователь, у которого будем запрашивать отзыв
   * @format int32
   */
  userId: number;
  organizationType: SravniOrganizationsSharedReviewObjectType;

  /** Идентификатор организации */
  organizationId: string;

  /** Код услуги из отзывов, опционально */
  serviceTag?: string | null;

  /** Идентификатор продукта с витрины, опционально */
  specificProductId?: string | null;

  /** Название продукта с витрины, опционально */
  specificProductName?: string | null;

  /**
   * Количество запросов для удаления, опционально
   * 2, если ничего не указано
   * @format int32
   */
  requestsToDelete?: number;

  /**
   * Дата начала уведомлений, опционально
   * Сразу, если ничего не указано
   * @format date-time
   */
  beginNotifyFrom?: string;

  /**
   * Планируемая дата удаления записи, опционально
   * Через месяц, если ничего не указано
   * @format date-time
   */
  deleteAt?: string;
}

/**
 * Модель запроса на отзыв
 */
export interface SravniReviewsModelsReviewRequestReviewRequestModel {
  /**
   * Идентификатор
   * @format int32
   */
  id?: number;

  /**
   * Пользователь, у которого будем запрашивать отзыв
   * @format int32
   */
  userId?: number;
  organizationType?: SravniOrganizationsSharedReviewObjectType;

  /** Идентификатор организации */
  organizationId?: string | null;

  /** Услуга */
  serviceTag?: string | null;

  /** Идентификатор продукта с витрины */
  specificProductId?: string | null;

  /** Название продукта с витрины */
  specificProductName?: string | null;

  /**
   * Количество запросов на текущий момент
   * Когда будет равно или превысит значение RequestsToDelete
   * запись будет подлежать удалению
   * @format int32
   */
  requestsMade?: number;

  /**
   * Количество запросов для удаления
   * @format int32
   */
  requestsToDelete?: number;

  /**
   * Дата создания
   * @format date-time
   */
  created?: string;

  /**
   * Дата начала уведомлений
   * @format date-time
   */
  beginNotifyFrom?: string;

  /**
   * Планируемая дата удаления записи
   * @format date-time
   */
  deleteAt?: string;
}

export interface SravniReviewsModelsSeoSeoOrganizationReviewsModel {
  alias?: string | null;
  organizationType?: SravniOrganizationsSharedReviewObjectType;

  /** @format int32 */
  reviewId?: number;
}

/**
 * Модель результата для seo-запроса всех отзывов по компании
 */
export interface SravniReviewsModelsSeoSeoReviewsModel {
  items?:
    | SystemCollectionsGenericKeyValuePair2SystemStringSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798ESystemCollectionsGenericIEnumerable1SystemInt32SystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798ESystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798E[]
    | null;
}

/**
 * Модель данных для сео сервиса
 */
export interface SravniReviewsModelsSeoSeoSummaryModel {
  /**
   * Количество отзывов
   * @format int32
   */
  reviewsCount?: number;

  /**
   * Количество отрицательных
   * @format int32
   */
  negativesCount?: number;

  /**
   * Количество положительных
   * @format int32
   */
  positivesCount?: number;

  /**
   * Количество с ответом организации
   * @format int32
   */
  answersCount?: number;

  /**
   * Количество с решением
   * @format int32
   */
  solutionsCount?: number;
}

export interface SravniReviewsModelsServiceTagModel {
  /** @format int32 */
  id?: number;
  name?: string | null;
  alias?: string | null;
  code?: string | null;
}

/**
 * Модель для чтения выжимок отзывов
 */
export interface SravniReviewsModelsSqueezeSqueezeBackofficeReadModel {
  /** Текст выжимки */
  text?: string | null;

  /** Является ли выжимка позитивной */
  isPositive?: boolean;

  /** Отзывы на которые ссылается эта выжимка */
  reviewIds?: number[] | null;

  /** Векторы, относящиеся к выжимке (если есть) */
  squeezeVectors?: SravniReviewsModelsSqueezeSqueezeVectorBackofficeReadModel[] | null;
}

export interface SravniReviewsModelsSqueezeSqueezeVectorBackofficeReadModel {
  /**
   * Идентификатор в БД
   * @format int32
   */
  id?: number;

  /** Текст */
  text?: string | null;

  /** Признак позитивного / негативного */
  isPositive?: boolean;
  reviewObjectType?: SravniOrganizationsSharedReviewObjectType;
  serviceTag?: SravniReviewsServiceModel;

  /**
   * Дата создания
   * @format date-time
   */
  modified?: string;

  /** Вектор удален */
  deleted?: boolean;

  /** Выжимки отзывов, которые лежат под этим вектором */
  squeezedReviews?: SravniReviewsModelsSqueezeSqueezeBackofficeReadModel[] | null;
}

/**
 * Модель векторов для ужатия отзывов
 */
export interface SravniReviewsModelsSqueezeSqueezeVectorModel {
  /**
   * Идентификатор в БД
   * @format int32
   */
  id?: number;

  /** Текст */
  text?: string | null;

  /** Признак позитивного / негативного */
  isPositive?: boolean;
  reviewObjectType?: SravniOrganizationsSharedReviewObjectType;
  serviceTag?: SravniReviewsServiceModel;

  /**
   * Дата создания
   * @format date-time
   */
  modified?: string;

  /** Вектор удален */
  deleted?: boolean;
}

/**
 * Модель для чтения выжимок отзывов
 */
export interface SravniReviewsModelsSqueezeSqueezedReviewsReadModel {
  /**
   * Идентификатор вектора
   * к которому относится эта выжимка
   * @format int32
   */
  vectorId?: number;

  /** Текст выжимки */
  text?: string | null;

  /** Является ли выжимка позитивной */
  isPositive?: boolean;

  /**
   * Количество выжимок по данному тексту
   * @format int32
   */
  count?: number;

  /**
   * Количество выжимок с оценкой отзыва 4 или 5
   * @format int32
   */
  highRatingCount?: number;
}

export interface SravniReviewsModelsUnpublishedCommentUnpublishedCommentModel {
  /**
   * Id черновика
   * @format int32
   */
  id?: number;

  /**
   * Id пользователя
   * @format int32
   */
  userId?: number | null;

  /**
   * Id отзыва
   * @format int32
   */
  reviewId?: number;

  /**
   * Id родительского комментария
   * @format int32
   */
  commentId?: number | null;

  /** Текст ответа(комментария) */
  text?: string | null;

  /**
   * Дата создания черновика
   * @format date-time
   */
  created?: string;

  /**
   * Дата обновления черновика
   * @format date-time
   */
  modified?: string | null;
}

export interface SravniReviewsModelsUnpublishedCommentUnpublishedCommentUpdateModel {
  /** @format int32 */
  reviewId?: number;

  /** @format int32 */
  commentId?: number | null;
  text?: string | null;
}

/**
 * Информация о модераторе
 */
export interface SravniReviewsModelsUsersModeratorInfoModel {
  /** @format int32 */
  id?: number;
  email?: string | null;
}

export interface SravniReviewsModelsUsersOrganizationUserModel {
  /**
   * Идентификатор пользователя
   * @format int32
   * @min 1
   * @max 2147483647
   */
  id: number;

  /** Идентификатор организации */
  organizationId: string;

  /** Присылать уведомления на почту */
  receiveNotifications?: boolean;

  /** Главный представитель */
  responsible?: boolean;

  /** Удален */
  deleted?: boolean;

  /**
   * Дата удаления/восстановления
   * @format date-time
   */
  deleteDate?: string | null;

  /**
   * Дата последнего ответа
   * @format date-time
   */
  lastReplyDate?: string | null;

  /** Есть демо ПУРа */
  reputationIsDemo?: boolean;

  /** Имя */
  firstName?: string | null;

  /** Фамилия */
  lastName?: string | null;

  /**
   * Дата последнего посещения ПУРа
   * @format date-time
   */
  lastReputationVisit?: string | null;
}

export interface SravniReviewsModelsUsersResponsibleOrganizationUserModel {
  /** @format int32 */
  id?: number;
  organizationId?: string | null;
  pseudonym?: string | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
}

export interface SravniReviewsModelsUsersUserBlockModel {
  /** @format int32 */
  id?: number;

  /** @format date-time */
  created?: string;

  /** @format int32 */
  userId?: number;
  userEmail?: string | null;
  userPhone?: string | null;
  userName?: string | null;
  userLastName?: string | null;

  /** @format int32 */
  blockedBy?: number;
  blockedByContact?: string | null;
  comment?: string | null;

  /** @format int32 */
  deletedBy?: number;
  deletedByContact?: string | null;
  deleted?: boolean;

  /** @format date-time */
  deleteDate?: string | null;
}

/**
 * Количество просмотров отзыва
 */
export interface SravniReviewsModelsViewsReviewViewsCountModel {
  /**
   * Id отзыва
   * @format int32
   */
  reviewId?: number;

  /**
   * Количество просмотров
   * @format int32
   */
  views?: number;
}

/**
 * Модель для получения пагинированного списка голосов у пользователя
 */
export interface SravniReviewsModelsVotesVoteReviewModel {
  /**
   * Id отзыва
   * @format int32
   */
  reviewId?: number;

  /** Возможно существующий Голос пользователя - true/false */
  userVote?: boolean | null;
  votes?: SravniReviewsModelsReviewVoteSummaryReadModel;
}

export interface SravniReviewsModeratorToOrganizationsModel {
  /** @format int32 */
  id?: number;
  userEmail?: string | null;
  organizationsIds?: string[] | null;
}

export interface SravniReviewsNameValueModel {
  name?: string | null;
  value?: any;
}

/**
 * Модель для постраничного вывода списка
 */
export interface SravniReviewsPagedModel1SravniReviewsClientToOrganizationModelSravniReviewsSharedVersion1000CultureNeutralPublicKeyTokenNull {
  /** часть списка */
  items?: SravniReviewsClientToOrganizationModel[] | null;

  /**
   * индекс страницы
   * @format int32
   */
  pageIndex?: number;

  /**
   * количество записей
   * @format int32
   */
  pageSize?: number;

  /**
   * общее количество записей
   * @format int32
   */
  total?: number;
}

/**
 * Модель для постраничного вывода списка
 */
export interface SravniReviewsPagedModel1SravniReviewsModelsAutoModerationAutoModerationHistoryModelSravniReviewsModelsVersion1000CultureNeutralPublicKeyTokenNull {
  /** часть списка */
  items?: SravniReviewsModelsAutoModerationAutoModerationHistoryModel[] | null;

  /**
   * индекс страницы
   * @format int32
   */
  pageIndex?: number;

  /**
   * количество записей
   * @format int32
   */
  pageSize?: number;

  /**
   * общее количество записей
   * @format int32
   */
  total?: number;
}

/**
 * Модель для постраничного вывода списка
 */
export interface SravniReviewsPagedModel1SravniReviewsModelsConfigurationsDictionaryConfigurationDictionaryModelSravniReviewsModelsVersion1000CultureNeutralPublicKeyTokenNull {
  /** часть списка */
  items?: SravniReviewsModelsConfigurationsDictionaryConfigurationDictionaryModel[] | null;

  /**
   * индекс страницы
   * @format int32
   */
  pageIndex?: number;

  /**
   * количество записей
   * @format int32
   */
  pageSize?: number;

  /**
   * общее количество записей
   * @format int32
   */
  total?: number;
}

/**
 * Модель для постраничного вывода списка
 */
export interface SravniReviewsPagedModel1SravniReviewsModelsDelayedReviewDelayedReviewModelSravniReviewsModelsVersion1000CultureNeutralPublicKeyTokenNull {
  /** часть списка */
  items?: SravniReviewsModelsDelayedReviewDelayedReviewModel[] | null;

  /**
   * индекс страницы
   * @format int32
   */
  pageIndex?: number;

  /**
   * количество записей
   * @format int32
   */
  pageSize?: number;

  /**
   * общее количество записей
   * @format int32
   */
  total?: number;
}

/**
 * Модель для постраничного вывода списка
 */
export interface SravniReviewsPagedModel1SravniReviewsModelsExternalApiExternalApiReviewModelSravniReviewsModelsVersion1000CultureNeutralPublicKeyTokenNull {
  /** часть списка */
  items?: SravniReviewsModelsExternalApiExternalApiReviewModel[] | null;

  /**
   * индекс страницы
   * @format int32
   */
  pageIndex?: number;

  /**
   * количество записей
   * @format int32
   */
  pageSize?: number;

  /**
   * общее количество записей
   * @format int32
   */
  total?: number;
}

/**
 * Модель для постраничного вывода списка
 */
export interface SravniReviewsPagedModel1SravniReviewsModelsExternalApiExternalApiReviewSortedByEventModelSravniReviewsModelsVersion1000CultureNeutralPublicKeyTokenNull {
  /** часть списка */
  items?: SravniReviewsModelsExternalApiExternalApiReviewSortedByEventModel[] | null;

  /**
   * индекс страницы
   * @format int32
   */
  pageIndex?: number;

  /**
   * количество записей
   * @format int32
   */
  pageSize?: number;

  /**
   * общее количество записей
   * @format int32
   */
  total?: number;
}

/**
 * Модель для постраничного вывода списка
 */
export interface SravniReviewsPagedModel1SravniReviewsModelsExternalApiExternalApiReviewWithUserDataModelSravniReviewsModelsVersion1000CultureNeutralPublicKeyTokenNull {
  /** часть списка */
  items?: SravniReviewsModelsExternalApiExternalApiReviewWithUserDataModel[] | null;

  /**
   * индекс страницы
   * @format int32
   */
  pageIndex?: number;

  /**
   * количество записей
   * @format int32
   */
  pageSize?: number;

  /**
   * общее количество записей
   * @format int32
   */
  total?: number;
}

/**
 * Модель для постраничного вывода списка
 */
export interface SravniReviewsPagedModel1SravniReviewsModelsExternalApiExternalApiReviewWithUserDataSortedByEventModelSravniReviewsModelsVersion1000CultureNeutralPublicKeyTokenNull {
  /** часть списка */
  items?: SravniReviewsModelsExternalApiExternalApiReviewWithUserDataSortedByEventModel[] | null;

  /**
   * индекс страницы
   * @format int32
   */
  pageIndex?: number;

  /**
   * количество записей
   * @format int32
   */
  pageSize?: number;

  /**
   * общее количество записей
   * @format int32
   */
  total?: number;
}

/**
 * Модель для постраничного вывода списка
 */
export interface SravniReviewsPagedModel1SravniReviewsModelsRatingBackofficeRatingModelSravniReviewsModelsVersion1000CultureNeutralPublicKeyTokenNull {
  /** часть списка */
  items?: SravniReviewsModelsRatingBackofficeRatingModel[] | null;

  /**
   * индекс страницы
   * @format int32
   */
  pageIndex?: number;

  /**
   * количество записей
   * @format int32
   */
  pageSize?: number;

  /**
   * общее количество записей
   * @format int32
   */
  total?: number;
}

/**
 * Модель для постраничного вывода списка
 */
export interface SravniReviewsPagedModel1SravniReviewsModelsReputationReputationDetailedStatsModelSravniReviewsModelsVersion1000CultureNeutralPublicKeyTokenNull {
  /** часть списка */
  items?: SravniReviewsModelsReputationReputationDetailedStatsModel[] | null;

  /**
   * индекс страницы
   * @format int32
   */
  pageIndex?: number;

  /**
   * количество записей
   * @format int32
   */
  pageSize?: number;

  /**
   * общее количество записей
   * @format int32
   */
  total?: number;
}

/**
 * Модель для постраничного вывода списка
 */
export interface SravniReviewsPagedModel1SravniReviewsModelsReviewBackofficeReviewCommentListItemModelSravniReviewsModelsVersion1000CultureNeutralPublicKeyTokenNull {
  /** часть списка */
  items?: SravniReviewsModelsReviewBackofficeReviewCommentListItemModel[] | null;

  /**
   * индекс страницы
   * @format int32
   */
  pageIndex?: number;

  /**
   * количество записей
   * @format int32
   */
  pageSize?: number;

  /**
   * общее количество записей
   * @format int32
   */
  total?: number;
}

/**
 * Модель для постраничного вывода списка
 */
export interface SravniReviewsPagedModel1SravniReviewsModelsReviewBackofficeReviewListItemModelSravniReviewsModelsVersion1000CultureNeutralPublicKeyTokenNull {
  /** часть списка */
  items?: SravniReviewsModelsReviewBackofficeReviewListItemModel[] | null;

  /**
   * индекс страницы
   * @format int32
   */
  pageIndex?: number;

  /**
   * количество записей
   * @format int32
   */
  pageSize?: number;

  /**
   * общее количество записей
   * @format int32
   */
  total?: number;
}

/**
 * Модель для постраничного вывода списка
 */
export interface SravniReviewsPagedModel1SravniReviewsModelsReviewReviewAdditionalInfoSchemeReadModelSravniReviewsModelsVersion1000CultureNeutralPublicKeyTokenNull {
  /** часть списка */
  items?: SravniReviewsModelsReviewReviewAdditionalInfoSchemeReadModel[] | null;

  /**
   * индекс страницы
   * @format int32
   */
  pageIndex?: number;

  /**
   * количество записей
   * @format int32
   */
  pageSize?: number;

  /**
   * общее количество записей
   * @format int32
   */
  total?: number;
}

/**
 * Модель для постраничного вывода списка
 */
export interface SravniReviewsPagedModel1SravniReviewsModelsReviewReviewCommentReadModelSravniReviewsModelsVersion1000CultureNeutralPublicKeyTokenNull {
  /** часть списка */
  items?: SravniReviewsModelsReviewReviewCommentReadModel[] | null;

  /**
   * индекс страницы
   * @format int32
   */
  pageIndex?: number;

  /**
   * количество записей
   * @format int32
   */
  pageSize?: number;

  /**
   * общее количество записей
   * @format int32
   */
  total?: number;
}

/**
 * Модель для постраничного вывода списка
 */
export interface SravniReviewsPagedModel1SravniReviewsModelsReviewReviewListItemModelSravniReviewsModelsVersion1000CultureNeutralPublicKeyTokenNull {
  /** часть списка */
  items?: SravniReviewsModelsReviewReviewListItemModel[] | null;

  /**
   * индекс страницы
   * @format int32
   */
  pageIndex?: number;

  /**
   * количество записей
   * @format int32
   */
  pageSize?: number;

  /**
   * общее количество записей
   * @format int32
   */
  total?: number;
}

/**
 * Модель для постраничного вывода списка
 */
export interface SravniReviewsPagedModel1SravniReviewsModelsSqueezeSqueezeBackofficeReadModelSravniReviewsModelsVersion1000CultureNeutralPublicKeyTokenNull {
  /** часть списка */
  items?: SravniReviewsModelsSqueezeSqueezeBackofficeReadModel[] | null;

  /**
   * индекс страницы
   * @format int32
   */
  pageIndex?: number;

  /**
   * количество записей
   * @format int32
   */
  pageSize?: number;

  /**
   * общее количество записей
   * @format int32
   */
  total?: number;
}

/**
 * Модель для постраничного вывода списка
 */
export interface SravniReviewsPagedModel1SravniReviewsModelsSqueezeSqueezeVectorModelSravniReviewsModelsVersion1000CultureNeutralPublicKeyTokenNull {
  /** часть списка */
  items?: SravniReviewsModelsSqueezeSqueezeVectorModel[] | null;

  /**
   * индекс страницы
   * @format int32
   */
  pageIndex?: number;

  /**
   * количество записей
   * @format int32
   */
  pageSize?: number;

  /**
   * общее количество записей
   * @format int32
   */
  total?: number;
}

/**
 * Модель для постраничного вывода списка
 */
export interface SravniReviewsPagedModel1SravniReviewsModelsSqueezeSqueezedReviewsReadModelSravniReviewsModelsVersion1000CultureNeutralPublicKeyTokenNull {
  /** часть списка */
  items?: SravniReviewsModelsSqueezeSqueezedReviewsReadModel[] | null;

  /**
   * индекс страницы
   * @format int32
   */
  pageIndex?: number;

  /**
   * количество записей
   * @format int32
   */
  pageSize?: number;

  /**
   * общее количество записей
   * @format int32
   */
  total?: number;
}

/**
 * Модель для постраничного вывода списка
 */
export interface SravniReviewsPagedModel1SravniReviewsModelsUnpublishedCommentUnpublishedCommentModelSravniReviewsModelsVersion1000CultureNeutralPublicKeyTokenNull {
  /** часть списка */
  items?: SravniReviewsModelsUnpublishedCommentUnpublishedCommentModel[] | null;

  /**
   * индекс страницы
   * @format int32
   */
  pageIndex?: number;

  /**
   * количество записей
   * @format int32
   */
  pageSize?: number;

  /**
   * общее количество записей
   * @format int32
   */
  total?: number;
}

/**
 * Модель для постраничного вывода списка
 */
export interface SravniReviewsPagedModel1SravniReviewsModelsUsersOrganizationUserModelSravniReviewsModelsVersion1000CultureNeutralPublicKeyTokenNull {
  /** часть списка */
  items?: SravniReviewsModelsUsersOrganizationUserModel[] | null;

  /**
   * индекс страницы
   * @format int32
   */
  pageIndex?: number;

  /**
   * количество записей
   * @format int32
   */
  pageSize?: number;

  /**
   * общее количество записей
   * @format int32
   */
  total?: number;
}

/**
 * Модель для постраничного вывода списка
 */
export interface SravniReviewsPagedModel1SravniReviewsModelsUsersUserBlockModelSravniReviewsModelsVersion1000CultureNeutralPublicKeyTokenNull {
  /** часть списка */
  items?: SravniReviewsModelsUsersUserBlockModel[] | null;

  /**
   * индекс страницы
   * @format int32
   */
  pageIndex?: number;

  /**
   * количество записей
   * @format int32
   */
  pageSize?: number;

  /**
   * общее количество записей
   * @format int32
   */
  total?: number;
}

/**
 * Модель для постраничного вывода списка
 */
export interface SravniReviewsPagedModel1SravniReviewsTagModelSravniReviewsSharedVersion1000CultureNeutralPublicKeyTokenNull {
  /** часть списка */
  items?: SravniReviewsTagModel[] | null;

  /**
   * индекс страницы
   * @format int32
   */
  pageIndex?: number;

  /**
   * количество записей
   * @format int32
   */
  pageSize?: number;

  /**
   * общее количество записей
   * @format int32
   */
  total?: number;
}

export interface SravniReviewsReviewTagModel {
  /** @format int32 */
  reviewId?: number;

  /** @format int32 */
  tagId?: number;
}

export interface SravniReviewsServiceModel {
  /** @format int32 */
  id?: number;
  name?: string | null;
  code?: string | null;
  alias?: string | null;
  deleted?: boolean;

  /** @format date-time */
  deleteDate?: string | null;
}

export interface SravniReviewsTagModel {
  /** @format int32 */
  id?: number;
  name?: string | null;
  alias?: string | null;
  isPositive?: boolean;
  description?: string | null;
  title?: string | null;
  deleted?: boolean;
  productTags?: string[] | null;
  services?: SravniReviewsServiceModel[] | null;
}

export interface SravniReviewsTagServiceModel {
  /** @format int32 */
  productTagId?: number;

  /** @format int32 */
  tagId?: number;
}

export interface SravniReviewsUpdateReviewTagModel {
  /** @format int32 */
  reviewId?: number;
  tagIds?: number[] | null;
}

export interface SravniReviewsUtm {
  utmSource?: string | null;
  utmCampaign?: string | null;
  utmMedium?: string | null;
}

export interface SystemCollectionsGenericKeyValuePair2SystemStringSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798ESystemCollectionsGenericIEnumerable1SystemInt32SystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798ESystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798E {
  key?: string | null;
  value?: number[] | null;
}

export interface AttachmentUploadCreatePayload {
  /** @format binary */
  file?: File;
}

export interface AutoModerationHistoryListParams {
  /**
   * Идентификатор истории
   * @format int32
   */
  Id?: number;

  /**
   * Идентификатор отзыва
   * @format int32
   */
  TargetReviewId?: number;

  /**
   * дата с
   * @format date-time
   */
  From?: string;

  /**
   * дата по
   * @format date-time
   */
  To?: string;

  /** организация целевого отзыва */
  OrganizationId?: string;

  /** услуга отзыва */
  Service?: string;

  /**
   * Индекс страницы
   * @format int32
   */
  PageIndex?: number;

  /**
   * Количество запрашиваемых сущностей
   * @format int32
   */
  PageSize?: number;
}

export interface OrganizationTokensListParams {
  /** Алиас организации */
  ClientId?: string;

  /** Идентификатор организации */
  OrganizationId?: string;

  /**
   * Индекс страницы
   * @format int32
   */
  PageIndex?: number;

  /**
   * Количество запрашиваемых сущностей
   * @format int32
   */
  PageSize?: number;
}

export interface CommentsListParams {
  /**
   * Id отзыва
   * @format int32
   * @min 1
   * @max 2147483647
   */
  ReviewId: number;

  /**
   * Id комментария
   * @format int32
   */
  ParentId?: number;

  /** Включать удаленные */
  IncludeDeleted?: boolean;

  /** Включать только ответы компаний */
  OnlyCompanyResponses?: boolean;

  /** Тип сортировки */
  OrderBy?: SravniReviewsEnumsCommentsOrderBy;

  /** Сортировка по возрастанию/убыванию */
  OrderDirection?: SravniReviewsEnumsOrderDirection;

  /**
   * Индекс страницы
   * @format int32
   */
  PageIndex?: number;

  /**
   * Количество запрашиваемых сущностей
   * @format int32
   */
  PageSize?: number;
}

export interface CommentUpdateAuthorNameCreateParams {
  /** @format int32 */
  userId?: number;
  name?: string;
  lastName?: string;
}

export interface ConfigurationsDictionaryListParams {
  /** Алиас(ключ) */
  Alias?: string;

  /**
   * Индекс страницы
   * @format int32
   */
  PageIndex?: number;

  /**
   * Количество запрашиваемых сущностей
   * @format int32
   */
  PageSize?: number;
}

export interface DelayedReviewsListParams {
  /** Массив идентификаторов отзывов */
  ReviewIds?: number[];

  /**
   * Индекс страницы
   * @format int32
   */
  PageIndex?: number;

  /**
   * Количество запрашиваемых сущностей
   * @format int32
   */
  PageSize?: number;
}

export interface DelayedReviewDeleteParams {
  /** @format int32 */
  id?: number;
}

export interface ExternalApiWithUserDataReviewsListParams {
  /**
   * Индекс страницы
   * @format int32
   * @min 0
   * @max 2147483647
   */
  PageIndex?: number;

  /**
   * Количество запрашиваемых сущностей
   * @format int32
   * @min 1
   * @max 100
   */
  PageSize?: number;
}

export interface ExternalApiWithUserDataReviewsSortedByEventListParams {
  /** Тип ивента по которому фильтруются сортируются отзывы */
  EventType?: SravniReviewsEnumsExternalApiActivityEventType;

  /**
   * Индекс страницы
   * @format int32
   * @min 0
   * @max 2147483647
   */
  PageIndex?: number;

  /**
   * Количество запрашиваемых сущностей
   * @format int32
   * @min 1
   * @max 100
   */
  PageSize?: number;
}

export interface ExternalApiReviewsListParams {
  /**
   * Индекс страницы
   * @format int32
   * @min 0
   * @max 2147483647
   */
  PageIndex?: number;

  /**
   * Количество запрашиваемых сущностей
   * @format int32
   * @min 1
   * @max 100
   */
  PageSize?: number;
}

export interface ExternalApiReviewsSortedByEventListParams {
  /** Тип ивента по которому фильтруются сортируются отзывы */
  EventType?: SravniReviewsEnumsExternalApiActivityEventType;

  /**
   * Индекс страницы
   * @format int32
   * @min 0
   * @max 2147483647
   */
  PageIndex?: number;

  /**
   * Количество запрашиваемых сущностей
   * @format int32
   * @min 1
   * @max 100
   */
  PageSize?: number;
}

export interface BackofficeReviewsListParams {
  /** Псевдоним автора */
  AuthorName?: string;

  /** Фамилия автора */
  AuthorLastName?: string;

  /** email автора */
  AuthorEmail?: string;

  /** Телефон */
  AuthorPhone?: string;

  /** IP пользователя */
  Ip?: string;

  /** FingerPrint пользователя */
  FingerPrint?: string;

  /** Фильтрация по мылу взявшего в модерацию */
  ModeratorEmail?: string;

  /**
   * null = не учитывает фильтр
   * true = отзывы с решенной проблемой
   * false = отзывы с нерешенной проблемой
   */
  HaveDocument?: boolean;

  /** Имя рекламного источника */
  UtmSource?: string;

  /** Имя рекламной компании */
  UtmCampaign?: string;

  /** Тип трафика */
  UtmMedium?: string;

  /** Признак того, что отзыв был оставлен клиентом Сравни */
  IsSravniClient?: boolean;

  /** Признак того, что отзыв был оставлен о Сравни */
  IsAboutSravni?: boolean;

  /** Поиск по данным браузера */
  UserAgent?: string;

  /** Поиск по хешированному номеру телефона */
  HashedPhoneNumber?: string;

  /** Поиск по типу спаршенного отзыва */
  ParsedReviewType?: SravniReviewsEnumsParsedReviewType;

  /** Тип удаления отзыва */
  DeleteReason?: SravniReviewsEnumsDeleteReason;

  /** Признак того, что отзыв был удален пользователем */
  IsDeleteByUser?: boolean;

  /**
   * дата с
   * @format date-time
   */
  From?: string;

  /**
   * дата по
   * @format date-time
   */
  To?: string;

  /** Мыльник модератора к организации */
  ModeratorToOrganizationEmail?: string;

  /** Отзывы  на контроле */
  FollowUpOnly?: boolean;

  /** Тип предмета отзыва */
  ReviewObjectType?: SravniOrganizationsSharedReviewObjectType;

  /** Тип организации в массиве */
  ReviewObjectTypes?: SravniOrganizationsSharedReviewObjectType[];

  /** Id предмета отзыва */
  ReviewObjectId?: string;

  /** Id предметов отзыва */
  ReviewObjectIds?: string[];

  /** Порядок сортировки отзывов */
  OrderBy?: SravniReviewsEnumsReviewOrder;

  /** Фильтрация отзывов */
  FilterBy?: SravniReviewsEnumsReviewFilter;

  /** Фильтрация по зачтённой оценке */
  Rated?: SravniReviewsEnumsReviewRate[];

  /** Фильтрация по проверяющейся оценке */
  CheckingRated?: SravniReviewsEnumsReviewRate[];

  /**
   * Фильтрация по идентификаторам векторов выжимок
   * От 0 до 20-ти
   */
  SqueezesVectorIds?: number[];

  /** Фильтрация по тэгу, если нужно. */
  Tag?:
    | 'unknown'
    | 'serviceLevel'
    | 'credits'
    | 'mortgage'
    | 'autocredits'
    | 'creditCards'
    | 'currencyExchange'
    | 'casco'
    | 'osago'
    | 'dsago'
    | 'homeInsurance'
    | 'travelInsurance'
    | 'moneyOrder'
    | 'greenCard'
    | 'priceQuality'
    | 'overallImpression'
    | 'aboutBuyingCarsFromAutoDealers'
    | 'microcredits'
    | 'debitCards'
    | 'remoteService'
    | 'businessDeposit'
    | 'businessCredits'
    | 'creditRefinancing'
    | 'investmentInsurance'
    | 'businessInsurance'
    | 'lifeInsurance'
    | 'responsibilityInsurance'
    | 'financialRiskInsurance'
    | 'pensionInsurance'
    | 'healthInsurance'
    | 'mortgageInsurance'
    | 'mortgageRefinancing'
    | 'businessRko'
    | 'factoring'
    | 'sportsInsurance'
    | 'acquiring'
    | 'business'
    | 'данные'
    | 'typeProgramming'
    | 'typeDesign'
    | 'typeManagement'
    | 'typeMarketing'
    | 'typeFinance'
    | 'typeAnalytics'
    | 'typeSoftSkills'
    | 'typeCreativity'
    | 'typeBeauty'
    | 'typeLanguage'
    | 'typeApplication'
    | 'sdelki'
    | 'otkrutie_scheta'
    | '654321'
    | '789'
    | '1547244'
    | '5723864'
    | 'Decor'
    | 'ApplicationAndWebsite'
    | 'ServiceErrors'
    | 'Interface'
    | 'Convenience'
    | 'Conditions'
    | 'techpodderzhka'
    | 'bonuses'
    | 'bets-variety '
    | 'Teachers'
    | 'Location'
    | 'Hostel'
    | 'Food'
    | 'other'
    | 'kursy'
    | 'Training_programs'
    | 'Payment'
    | 'Appp'
    | 'Insurance'
    | 'learning_process'
    | 'Support'
    | 'Vuvod_sredstv'
    | 'Uslovia_i_tarif'
    | 'Duration'
    | 'Functional'
    | 'Price'
    | 'Education'
    | 'egeOge'
    | 'dasdas'
    | 'asdsaads'
    | 'leasing'
    | 'biznesRegistration'
    | 'biznesNaMarketpleysakh'
    | 'bukhgalteriyaDlyaBiznesa'
    | 'savings'
    | '1234'
    | ' uslugaeda'
    | 'super-eda'
    | 'superedaeda'
    | '999367'
    | '9546738'
    | 'quality'
    | 'npf-fiz-uslugaa'
    | 'quality-of-food'
    | 'delivery'
    | 'package'
    | 'menu'
    | 'loyalty-program'
    | 'kittens'
    | 'strakhovaniyeOtUkusaKleshcha'
    | 'stavki';

  /** Фильтрация по тэгу группы. */
  GroupTag?:
    | 'SAD'
    | 'test'
    | 'ыфввыф'
    | '333333333'
    | 'Decor'
    | 'Conditions'
    | 'bets-variety '
    | 'asdsaads'
    | 'strakhovaniyeOtUkusaKleshcha'
    | 'business'
    | 'bukhgalteriyaDlyaBiznesa'
    | 'other'
    | 'kursy'
    | 'Training_programs'
    | 'Payment'
    | 'Appp'
    | 'Insurance'
    | 'learning_process'
    | 'Support'
    | 'Vuvod_sredstv'
    | 'Uslovia_i_tarif'
    | 'Duration'
    | 'Functional'
    | 'Price'
    | 'Education'
    | '333'
    | '426822347';

  /** Включать удаленные */
  Deleted?: boolean;

  /** Заголовок/часть заголовка */
  Title?: string;

  /** Текст/часть текста */
  Text?: string;

  /** Роут локации отзыва */
  LocationRoute?: string;

  /** Роут локации отзыва нового формата */
  LocationGarRoute?: string;

  /**
   * id локации
   * @format int32
   */
  LocationId?: number;

  /**
   * GarId локации
   * @format int32
   */
  LocationGarId?: number;

  /** Статус оценки */
  RateStatus?: SravniReviewsEnumsReviewRateStatus;

  /**
   * Id отзыва (для списка комментариев)
   * @format int32
   */
  ReviewId?: number;

  /** статус комментария //todo: поправить нейминг */
  ReviewStatus?: SravniReviewsEnumsReviewStatus;

  /** статус наличия ответа от компании */
  HasCompanyResponse?: boolean;

  /** Id продукта любой витрины */
  SpecificProductId?: string;

  /** true - отзывы юриков; false - отзывы физиков; null - все отзывы */
  IsLegal?: boolean;

  /** true - есть персональные данные пользователя; false - нет персональных данных пользователя; null - все отзывы */
  HasPersonalData?: boolean;

  /** Предпочитать MongoID вместо INT */
  NewIds?: boolean;

  /** Возвращает по одному отзыву (если есть) на организацию */
  UniqueOnly?: boolean;

  /** Включать лайки? (не фильтр) */
  WithVotes?: boolean;

  /** Идентификаторы отзывов для поиска по айдишникам */
  ReviewIds?: number[];

  /** Идентификаторы пользователей */
  UserIds?: number[];

  /**
   * Индекс страницы
   * @format int32
   */
  PageIndex?: number;

  /**
   * Количество запрашиваемых сущностей
   * @format int32
   */
  PageSize?: number;
}

export interface ReportsBackofficeReviewsContentListParams {
  /** Псевдоним автора */
  AuthorName?: string;

  /** Фамилия автора */
  AuthorLastName?: string;

  /** email автора */
  AuthorEmail?: string;

  /** Телефон */
  AuthorPhone?: string;

  /** IP пользователя */
  Ip?: string;

  /** FingerPrint пользователя */
  FingerPrint?: string;

  /** Фильтрация по мылу взявшего в модерацию */
  ModeratorEmail?: string;

  /**
   * null = не учитывает фильтр
   * true = отзывы с решенной проблемой
   * false = отзывы с нерешенной проблемой
   */
  HaveDocument?: boolean;

  /** Имя рекламного источника */
  UtmSource?: string;

  /** Имя рекламной компании */
  UtmCampaign?: string;

  /** Тип трафика */
  UtmMedium?: string;

  /** Признак того, что отзыв был оставлен клиентом Сравни */
  IsSravniClient?: boolean;

  /** Признак того, что отзыв был оставлен о Сравни */
  IsAboutSravni?: boolean;

  /** Поиск по данным браузера */
  UserAgent?: string;

  /** Поиск по хешированному номеру телефона */
  HashedPhoneNumber?: string;

  /** Поиск по типу спаршенного отзыва */
  ParsedReviewType?: SravniReviewsEnumsParsedReviewType;

  /** Тип удаления отзыва */
  DeleteReason?: SravniReviewsEnumsDeleteReason;

  /** Признак того, что отзыв был удален пользователем */
  IsDeleteByUser?: boolean;

  /**
   * дата с
   * @format date-time
   */
  From?: string;

  /**
   * дата по
   * @format date-time
   */
  To?: string;

  /** Мыльник модератора к организации */
  ModeratorToOrganizationEmail?: string;

  /** Отзывы  на контроле */
  FollowUpOnly?: boolean;

  /** Тип предмета отзыва */
  ReviewObjectType?: SravniOrganizationsSharedReviewObjectType;

  /** Тип организации в массиве */
  ReviewObjectTypes?: SravniOrganizationsSharedReviewObjectType[];

  /** Id предмета отзыва */
  ReviewObjectId?: string;

  /** Id предметов отзыва */
  ReviewObjectIds?: string[];

  /** Порядок сортировки отзывов */
  OrderBy?: SravniReviewsEnumsReviewOrder;

  /** Фильтрация отзывов */
  FilterBy?: SravniReviewsEnumsReviewFilter;

  /** Фильтрация по зачтённой оценке */
  Rated?: SravniReviewsEnumsReviewRate[];

  /** Фильтрация по проверяющейся оценке */
  CheckingRated?: SravniReviewsEnumsReviewRate[];

  /**
   * Фильтрация по идентификаторам векторов выжимок
   * От 0 до 20-ти
   */
  SqueezesVectorIds?: number[];

  /** Фильтрация по тэгу, если нужно. */
  Tag?:
    | 'unknown'
    | 'serviceLevel'
    | 'credits'
    | 'mortgage'
    | 'autocredits'
    | 'creditCards'
    | 'currencyExchange'
    | 'casco'
    | 'osago'
    | 'dsago'
    | 'homeInsurance'
    | 'travelInsurance'
    | 'moneyOrder'
    | 'greenCard'
    | 'priceQuality'
    | 'overallImpression'
    | 'aboutBuyingCarsFromAutoDealers'
    | 'microcredits'
    | 'debitCards'
    | 'remoteService'
    | 'businessDeposit'
    | 'businessCredits'
    | 'creditRefinancing'
    | 'investmentInsurance'
    | 'businessInsurance'
    | 'lifeInsurance'
    | 'responsibilityInsurance'
    | 'financialRiskInsurance'
    | 'pensionInsurance'
    | 'healthInsurance'
    | 'mortgageInsurance'
    | 'mortgageRefinancing'
    | 'businessRko'
    | 'factoring'
    | 'sportsInsurance'
    | 'acquiring'
    | 'business'
    | 'данные'
    | 'typeProgramming'
    | 'typeDesign'
    | 'typeManagement'
    | 'typeMarketing'
    | 'typeFinance'
    | 'typeAnalytics'
    | 'typeSoftSkills'
    | 'typeCreativity'
    | 'typeBeauty'
    | 'typeLanguage'
    | 'typeApplication'
    | 'sdelki'
    | 'otkrutie_scheta'
    | '654321'
    | '789'
    | '1547244'
    | '5723864'
    | 'Decor'
    | 'ApplicationAndWebsite'
    | 'ServiceErrors'
    | 'Interface'
    | 'Convenience'
    | 'Conditions'
    | 'techpodderzhka'
    | 'bonuses'
    | 'bets-variety '
    | 'Teachers'
    | 'Location'
    | 'Hostel'
    | 'Food'
    | 'other'
    | 'kursy'
    | 'Training_programs'
    | 'Payment'
    | 'Appp'
    | 'Insurance'
    | 'learning_process'
    | 'Support'
    | 'Vuvod_sredstv'
    | 'Uslovia_i_tarif'
    | 'Duration'
    | 'Functional'
    | 'Price'
    | 'Education'
    | 'egeOge'
    | 'dasdas'
    | 'asdsaads'
    | 'leasing'
    | 'biznesRegistration'
    | 'biznesNaMarketpleysakh'
    | 'bukhgalteriyaDlyaBiznesa'
    | 'savings'
    | '1234'
    | ' uslugaeda'
    | 'super-eda'
    | 'superedaeda'
    | '999367'
    | '9546738'
    | 'quality'
    | 'npf-fiz-uslugaa'
    | 'quality-of-food'
    | 'delivery'
    | 'package'
    | 'menu'
    | 'loyalty-program'
    | 'kittens'
    | 'strakhovaniyeOtUkusaKleshcha'
    | 'stavki';

  /** Фильтрация по тэгу группы. */
  GroupTag?:
    | 'SAD'
    | 'test'
    | 'ыфввыф'
    | '333333333'
    | 'Decor'
    | 'Conditions'
    | 'bets-variety '
    | 'asdsaads'
    | 'strakhovaniyeOtUkusaKleshcha'
    | 'business'
    | 'bukhgalteriyaDlyaBiznesa'
    | 'other'
    | 'kursy'
    | 'Training_programs'
    | 'Payment'
    | 'Appp'
    | 'Insurance'
    | 'learning_process'
    | 'Support'
    | 'Vuvod_sredstv'
    | 'Uslovia_i_tarif'
    | 'Duration'
    | 'Functional'
    | 'Price'
    | 'Education'
    | '333'
    | '426822347';

  /** Включать удаленные */
  Deleted?: boolean;

  /** Заголовок/часть заголовка */
  Title?: string;

  /** Текст/часть текста */
  Text?: string;

  /** Роут локации отзыва */
  LocationRoute?: string;

  /** Роут локации отзыва нового формата */
  LocationGarRoute?: string;

  /**
   * id локации
   * @format int32
   */
  LocationId?: number;

  /**
   * GarId локации
   * @format int32
   */
  LocationGarId?: number;

  /** Статус оценки */
  RateStatus?: SravniReviewsEnumsReviewRateStatus;

  /**
   * Id отзыва (для списка комментариев)
   * @format int32
   */
  ReviewId?: number;

  /** статус комментария //todo: поправить нейминг */
  ReviewStatus?: SravniReviewsEnumsReviewStatus;

  /** статус наличия ответа от компании */
  HasCompanyResponse?: boolean;

  /** Id продукта любой витрины */
  SpecificProductId?: string;

  /** true - отзывы юриков; false - отзывы физиков; null - все отзывы */
  IsLegal?: boolean;

  /** true - есть персональные данные пользователя; false - нет персональных данных пользователя; null - все отзывы */
  HasPersonalData?: boolean;

  /** Предпочитать MongoID вместо INT */
  NewIds?: boolean;

  /** Возвращает по одному отзыву (если есть) на организацию */
  UniqueOnly?: boolean;

  /** Включать лайки? (не фильтр) */
  WithVotes?: boolean;

  /** Идентификаторы отзывов для поиска по айдишникам */
  ReviewIds?: number[];

  /** Идентификаторы пользователей */
  UserIds?: number[];

  /**
   * Индекс страницы
   * @format int32
   */
  PageIndex?: number;

  /**
   * Количество запрашиваемых сущностей
   * @format int32
   */
  PageSize?: number;
}

export interface ReportsBackofficeFollowupReviewsContentListParams {
  /** Псевдоним автора */
  AuthorName?: string;

  /** Фамилия автора */
  AuthorLastName?: string;

  /** email автора */
  AuthorEmail?: string;

  /** Телефон */
  AuthorPhone?: string;

  /** IP пользователя */
  Ip?: string;

  /** FingerPrint пользователя */
  FingerPrint?: string;

  /** Фильтрация по мылу взявшего в модерацию */
  ModeratorEmail?: string;

  /**
   * null = не учитывает фильтр
   * true = отзывы с решенной проблемой
   * false = отзывы с нерешенной проблемой
   */
  HaveDocument?: boolean;

  /** Имя рекламного источника */
  UtmSource?: string;

  /** Имя рекламной компании */
  UtmCampaign?: string;

  /** Тип трафика */
  UtmMedium?: string;

  /** Признак того, что отзыв был оставлен клиентом Сравни */
  IsSravniClient?: boolean;

  /** Признак того, что отзыв был оставлен о Сравни */
  IsAboutSravni?: boolean;

  /** Поиск по данным браузера */
  UserAgent?: string;

  /** Поиск по хешированному номеру телефона */
  HashedPhoneNumber?: string;

  /** Поиск по типу спаршенного отзыва */
  ParsedReviewType?: SravniReviewsEnumsParsedReviewType;

  /** Тип удаления отзыва */
  DeleteReason?: SravniReviewsEnumsDeleteReason;

  /** Признак того, что отзыв был удален пользователем */
  IsDeleteByUser?: boolean;

  /**
   * дата с
   * @format date-time
   */
  From?: string;

  /**
   * дата по
   * @format date-time
   */
  To?: string;

  /** Мыльник модератора к организации */
  ModeratorToOrganizationEmail?: string;

  /** Отзывы  на контроле */
  FollowUpOnly?: boolean;

  /** Тип предмета отзыва */
  ReviewObjectType?: SravniOrganizationsSharedReviewObjectType;

  /** Тип организации в массиве */
  ReviewObjectTypes?: SravniOrganizationsSharedReviewObjectType[];

  /** Id предмета отзыва */
  ReviewObjectId?: string;

  /** Id предметов отзыва */
  ReviewObjectIds?: string[];

  /** Порядок сортировки отзывов */
  OrderBy?: SravniReviewsEnumsReviewOrder;

  /** Фильтрация отзывов */
  FilterBy?: SravniReviewsEnumsReviewFilter;

  /** Фильтрация по зачтённой оценке */
  Rated?: SravniReviewsEnumsReviewRate[];

  /** Фильтрация по проверяющейся оценке */
  CheckingRated?: SravniReviewsEnumsReviewRate[];

  /**
   * Фильтрация по идентификаторам векторов выжимок
   * От 0 до 20-ти
   */
  SqueezesVectorIds?: number[];

  /** Фильтрация по тэгу, если нужно. */
  Tag?:
    | 'unknown'
    | 'serviceLevel'
    | 'credits'
    | 'mortgage'
    | 'autocredits'
    | 'creditCards'
    | 'currencyExchange'
    | 'casco'
    | 'osago'
    | 'dsago'
    | 'homeInsurance'
    | 'travelInsurance'
    | 'moneyOrder'
    | 'greenCard'
    | 'priceQuality'
    | 'overallImpression'
    | 'aboutBuyingCarsFromAutoDealers'
    | 'microcredits'
    | 'debitCards'
    | 'remoteService'
    | 'businessDeposit'
    | 'businessCredits'
    | 'creditRefinancing'
    | 'investmentInsurance'
    | 'businessInsurance'
    | 'lifeInsurance'
    | 'responsibilityInsurance'
    | 'financialRiskInsurance'
    | 'pensionInsurance'
    | 'healthInsurance'
    | 'mortgageInsurance'
    | 'mortgageRefinancing'
    | 'businessRko'
    | 'factoring'
    | 'sportsInsurance'
    | 'acquiring'
    | 'business'
    | 'данные'
    | 'typeProgramming'
    | 'typeDesign'
    | 'typeManagement'
    | 'typeMarketing'
    | 'typeFinance'
    | 'typeAnalytics'
    | 'typeSoftSkills'
    | 'typeCreativity'
    | 'typeBeauty'
    | 'typeLanguage'
    | 'typeApplication'
    | 'sdelki'
    | 'otkrutie_scheta'
    | '654321'
    | '789'
    | '1547244'
    | '5723864'
    | 'Decor'
    | 'ApplicationAndWebsite'
    | 'ServiceErrors'
    | 'Interface'
    | 'Convenience'
    | 'Conditions'
    | 'techpodderzhka'
    | 'bonuses'
    | 'bets-variety '
    | 'Teachers'
    | 'Location'
    | 'Hostel'
    | 'Food'
    | 'other'
    | 'kursy'
    | 'Training_programs'
    | 'Payment'
    | 'Appp'
    | 'Insurance'
    | 'learning_process'
    | 'Support'
    | 'Vuvod_sredstv'
    | 'Uslovia_i_tarif'
    | 'Duration'
    | 'Functional'
    | 'Price'
    | 'Education'
    | 'egeOge'
    | 'dasdas'
    | 'asdsaads'
    | 'leasing'
    | 'biznesRegistration'
    | 'biznesNaMarketpleysakh'
    | 'bukhgalteriyaDlyaBiznesa'
    | 'savings'
    | '1234'
    | ' uslugaeda'
    | 'super-eda'
    | 'superedaeda'
    | '999367'
    | '9546738'
    | 'quality'
    | 'npf-fiz-uslugaa'
    | 'quality-of-food'
    | 'delivery'
    | 'package'
    | 'menu'
    | 'loyalty-program'
    | 'kittens'
    | 'strakhovaniyeOtUkusaKleshcha'
    | 'stavki';

  /** Фильтрация по тэгу группы. */
  GroupTag?:
    | 'SAD'
    | 'test'
    | 'ыфввыф'
    | '333333333'
    | 'Decor'
    | 'Conditions'
    | 'bets-variety '
    | 'asdsaads'
    | 'strakhovaniyeOtUkusaKleshcha'
    | 'business'
    | 'bukhgalteriyaDlyaBiznesa'
    | 'other'
    | 'kursy'
    | 'Training_programs'
    | 'Payment'
    | 'Appp'
    | 'Insurance'
    | 'learning_process'
    | 'Support'
    | 'Vuvod_sredstv'
    | 'Uslovia_i_tarif'
    | 'Duration'
    | 'Functional'
    | 'Price'
    | 'Education'
    | '333'
    | '426822347';

  /** Включать удаленные */
  Deleted?: boolean;

  /** Заголовок/часть заголовка */
  Title?: string;

  /** Текст/часть текста */
  Text?: string;

  /** Роут локации отзыва */
  LocationRoute?: string;

  /** Роут локации отзыва нового формата */
  LocationGarRoute?: string;

  /**
   * id локации
   * @format int32
   */
  LocationId?: number;

  /**
   * GarId локации
   * @format int32
   */
  LocationGarId?: number;

  /** Статус оценки */
  RateStatus?: SravniReviewsEnumsReviewRateStatus;

  /**
   * Id отзыва (для списка комментариев)
   * @format int32
   */
  ReviewId?: number;

  /** статус комментария //todo: поправить нейминг */
  ReviewStatus?: SravniReviewsEnumsReviewStatus;

  /** статус наличия ответа от компании */
  HasCompanyResponse?: boolean;

  /** Id продукта любой витрины */
  SpecificProductId?: string;

  /** true - отзывы юриков; false - отзывы физиков; null - все отзывы */
  IsLegal?: boolean;

  /** true - есть персональные данные пользователя; false - нет персональных данных пользователя; null - все отзывы */
  HasPersonalData?: boolean;

  /** Предпочитать MongoID вместо INT */
  NewIds?: boolean;

  /** Возвращает по одному отзыву (если есть) на организацию */
  UniqueOnly?: boolean;

  /** Включать лайки? (не фильтр) */
  WithVotes?: boolean;

  /** Идентификаторы отзывов для поиска по айдишникам */
  ReviewIds?: number[];

  /** Идентификаторы пользователей */
  UserIds?: number[];

  /**
   * Индекс страницы
   * @format int32
   */
  PageIndex?: number;

  /**
   * Количество запрашиваемых сущностей
   * @format int32
   */
  PageSize?: number;
}

/**
 * @format int32
 */
export type ManageReviewPartialUpdatePayload = number;

/**
 * @format int32
 */
export type ManageCommentPartialUpdatePayload = number;

/**
 * @format int32
 */
export type ManageReviewRequireDocumentsUpdatePayload = number;

/**
 * @format int32
 */
export type ReviewRequireDocumentsUpdatePayload = number;

/**
 * @format int32
 */
export type ManageReviewApproveDocumentsUpdatePayload = number;

/**
 * @format int32
 */
export type ReviewApproveDocumentsUpdatePayload = number;

/**
 * @format int32
 */
export type ManageReviewFollowUpCreatePayload = number;

export interface BackofficeCommentsListParams {
  /** Тип предмета отзыва */
  ReviewObjectType?: SravniOrganizationsSharedReviewObjectType;

  /** Id предмета отзыва */
  ReviewObjectId?: string;

  /** Порядок сортировки */
  OrderBy?: SravniReviewsEnumsReviewOrder;

  /** Фильтрация по тэгу, если нужно. */
  Tag?:
    | 'unknown'
    | 'serviceLevel'
    | 'credits'
    | 'mortgage'
    | 'autocredits'
    | 'creditCards'
    | 'currencyExchange'
    | 'casco'
    | 'osago'
    | 'dsago'
    | 'homeInsurance'
    | 'travelInsurance'
    | 'moneyOrder'
    | 'greenCard'
    | 'priceQuality'
    | 'overallImpression'
    | 'aboutBuyingCarsFromAutoDealers'
    | 'microcredits'
    | 'debitCards'
    | 'remoteService'
    | 'businessDeposit'
    | 'businessCredits'
    | 'creditRefinancing'
    | 'investmentInsurance'
    | 'businessInsurance'
    | 'lifeInsurance'
    | 'responsibilityInsurance'
    | 'financialRiskInsurance'
    | 'pensionInsurance'
    | 'healthInsurance'
    | 'mortgageInsurance'
    | 'mortgageRefinancing'
    | 'businessRko'
    | 'factoring'
    | 'sportsInsurance'
    | 'acquiring'
    | 'business'
    | 'данные'
    | 'typeProgramming'
    | 'typeDesign'
    | 'typeManagement'
    | 'typeMarketing'
    | 'typeFinance'
    | 'typeAnalytics'
    | 'typeSoftSkills'
    | 'typeCreativity'
    | 'typeBeauty'
    | 'typeLanguage'
    | 'typeApplication'
    | 'sdelki'
    | 'otkrutie_scheta'
    | '654321'
    | '789'
    | '1547244'
    | '5723864'
    | 'Decor'
    | 'ApplicationAndWebsite'
    | 'ServiceErrors'
    | 'Interface'
    | 'Convenience'
    | 'Conditions'
    | 'techpodderzhka'
    | 'bonuses'
    | 'bets-variety '
    | 'Teachers'
    | 'Location'
    | 'Hostel'
    | 'Food'
    | 'other'
    | 'kursy'
    | 'Training_programs'
    | 'Payment'
    | 'Appp'
    | 'Insurance'
    | 'learning_process'
    | 'Support'
    | 'Vuvod_sredstv'
    | 'Uslovia_i_tarif'
    | 'Duration'
    | 'Functional'
    | 'Price'
    | 'Education'
    | 'egeOge'
    | 'dasdas'
    | 'asdsaads'
    | 'leasing'
    | 'biznesRegistration'
    | 'biznesNaMarketpleysakh'
    | 'bukhgalteriyaDlyaBiznesa'
    | 'savings'
    | '1234'
    | ' uslugaeda'
    | 'super-eda'
    | 'superedaeda'
    | '999367'
    | '9546738'
    | 'quality'
    | 'npf-fiz-uslugaa'
    | 'quality-of-food'
    | 'delivery'
    | 'package'
    | 'menu'
    | 'loyalty-program'
    | 'kittens'
    | 'strakhovaniyeOtUkusaKleshcha'
    | 'stavki';

  /** Выбирать только по одному отзыву для банка */
  GroupedByBanks?: boolean;

  /** Id локации отзыва */
  LocationRoute?: string;

  /** GarId локации отзыва */
  LocationGarRoute?: string;

  /** Включать удаленные */
  Deleted?: boolean;

  /** Заголовок/часть заголовка */
  Title?: string;

  /** Псевдоним автора */
  AuthorName?: string;

  /** Фамилия автора */
  AuthorLastName?: string;

  /** email автора */
  AuthorEmail?: string;

  /**
   * дата с
   * @format date-time
   */
  From?: string;

  /**
   * дата по
   * @format date-time
   */
  To?: string;

  /**
   * id локации
   * @format int32
   */
  LocationId?: number;

  /**
   * GarId локации
   * @format int32
   */
  LocationGarId?: number;

  /** IP пользователя */
  Ip?: string;

  /** FingerPrint пользователя */
  FingerPrint?: string;

  /**
   * Id отзыва (для списка комментариев)
   * @format int32
   */
  ReviewId?: number;

  /** статус комментария //todo: поправить нейминг */
  ReviewStatus?: SravniReviewsEnumsReviewStatus;

  /** статус отзыва у комментария //todo: поправить нейминг */
  CommentReviewStatus?: SravniReviewsEnumsReviewStatus;

  /** Телефон */
  AuthorPhone?: string;

  /** Предпочитать MongoID вместо INT */
  NewIds?: boolean;

  /** Фильтрация по роли оставившего комментарий */
  ReviewAuthorRoleType?: SravniReviewsEnumsReviewAuthorRoleType;

  /** Идентификаторы пользователей */
  UserIds?: number[];

  /** Мыльник модератора к организации */
  ModeratorToOrganizationEmail?: string;

  /** Какая роль была у удаляющего комментарий */
  DeletedCommentsByRoleTypes?: SravniReviewsEnumsDeletedCommentsByRoleType[];

  /** Коммент удалился при удалении отзыва или вручную */
  IsCommentAutomaticallyDeleted?: boolean;

  /**
   * Индекс страницы
   * @format int32
   */
  PageIndex?: number;

  /**
   * Количество запрашиваемых сущностей
   * @format int32
   */
  PageSize?: number;
}

export interface ReportsBackofficeCommentsContentListParams {
  /** Тип предмета отзыва */
  ReviewObjectType?: SravniOrganizationsSharedReviewObjectType;

  /** Id предмета отзыва */
  ReviewObjectId?: string;

  /** Порядок сортировки */
  OrderBy?: SravniReviewsEnumsReviewOrder;

  /** Фильтрация по тэгу, если нужно. */
  Tag?:
    | 'unknown'
    | 'serviceLevel'
    | 'credits'
    | 'mortgage'
    | 'autocredits'
    | 'creditCards'
    | 'currencyExchange'
    | 'casco'
    | 'osago'
    | 'dsago'
    | 'homeInsurance'
    | 'travelInsurance'
    | 'moneyOrder'
    | 'greenCard'
    | 'priceQuality'
    | 'overallImpression'
    | 'aboutBuyingCarsFromAutoDealers'
    | 'microcredits'
    | 'debitCards'
    | 'remoteService'
    | 'businessDeposit'
    | 'businessCredits'
    | 'creditRefinancing'
    | 'investmentInsurance'
    | 'businessInsurance'
    | 'lifeInsurance'
    | 'responsibilityInsurance'
    | 'financialRiskInsurance'
    | 'pensionInsurance'
    | 'healthInsurance'
    | 'mortgageInsurance'
    | 'mortgageRefinancing'
    | 'businessRko'
    | 'factoring'
    | 'sportsInsurance'
    | 'acquiring'
    | 'business'
    | 'данные'
    | 'typeProgramming'
    | 'typeDesign'
    | 'typeManagement'
    | 'typeMarketing'
    | 'typeFinance'
    | 'typeAnalytics'
    | 'typeSoftSkills'
    | 'typeCreativity'
    | 'typeBeauty'
    | 'typeLanguage'
    | 'typeApplication'
    | 'sdelki'
    | 'otkrutie_scheta'
    | '654321'
    | '789'
    | '1547244'
    | '5723864'
    | 'Decor'
    | 'ApplicationAndWebsite'
    | 'ServiceErrors'
    | 'Interface'
    | 'Convenience'
    | 'Conditions'
    | 'techpodderzhka'
    | 'bonuses'
    | 'bets-variety '
    | 'Teachers'
    | 'Location'
    | 'Hostel'
    | 'Food'
    | 'other'
    | 'kursy'
    | 'Training_programs'
    | 'Payment'
    | 'Appp'
    | 'Insurance'
    | 'learning_process'
    | 'Support'
    | 'Vuvod_sredstv'
    | 'Uslovia_i_tarif'
    | 'Duration'
    | 'Functional'
    | 'Price'
    | 'Education'
    | 'egeOge'
    | 'dasdas'
    | 'asdsaads'
    | 'leasing'
    | 'biznesRegistration'
    | 'biznesNaMarketpleysakh'
    | 'bukhgalteriyaDlyaBiznesa'
    | 'savings'
    | '1234'
    | ' uslugaeda'
    | 'super-eda'
    | 'superedaeda'
    | '999367'
    | '9546738'
    | 'quality'
    | 'npf-fiz-uslugaa'
    | 'quality-of-food'
    | 'delivery'
    | 'package'
    | 'menu'
    | 'loyalty-program'
    | 'kittens'
    | 'strakhovaniyeOtUkusaKleshcha'
    | 'stavki';

  /** Выбирать только по одному отзыву для банка */
  GroupedByBanks?: boolean;

  /** Id локации отзыва */
  LocationRoute?: string;

  /** GarId локации отзыва */
  LocationGarRoute?: string;

  /** Включать удаленные */
  Deleted?: boolean;

  /** Заголовок/часть заголовка */
  Title?: string;

  /** Псевдоним автора */
  AuthorName?: string;

  /** Фамилия автора */
  AuthorLastName?: string;

  /** email автора */
  AuthorEmail?: string;

  /**
   * дата с
   * @format date-time
   */
  From?: string;

  /**
   * дата по
   * @format date-time
   */
  To?: string;

  /**
   * id локации
   * @format int32
   */
  LocationId?: number;

  /**
   * GarId локации
   * @format int32
   */
  LocationGarId?: number;

  /** IP пользователя */
  Ip?: string;

  /** FingerPrint пользователя */
  FingerPrint?: string;

  /**
   * Id отзыва (для списка комментариев)
   * @format int32
   */
  ReviewId?: number;

  /** статус комментария //todo: поправить нейминг */
  ReviewStatus?: SravniReviewsEnumsReviewStatus;

  /** статус отзыва у комментария //todo: поправить нейминг */
  CommentReviewStatus?: SravniReviewsEnumsReviewStatus;

  /** Телефон */
  AuthorPhone?: string;

  /** Предпочитать MongoID вместо INT */
  NewIds?: boolean;

  /** Фильтрация по роли оставившего комментарий */
  ReviewAuthorRoleType?: SravniReviewsEnumsReviewAuthorRoleType;

  /** Идентификаторы пользователей */
  UserIds?: number[];

  /** Мыльник модератора к организации */
  ModeratorToOrganizationEmail?: string;

  /** Какая роль была у удаляющего комментарий */
  DeletedCommentsByRoleTypes?: SravniReviewsEnumsDeletedCommentsByRoleType[];

  /** Коммент удалился при удалении отзыва или вручную */
  IsCommentAutomaticallyDeleted?: boolean;

  /**
   * Индекс страницы
   * @format int32
   */
  PageIndex?: number;

  /**
   * Количество запрашиваемых сущностей
   * @format int32
   */
  PageSize?: number;
}

export interface ManageUsersBlocksListParams {
  /** Имя/тел/email для поиска */
  Term?: string;

  /**
   * Id Пользователя
   * @format int32
   */
  UserId?: number;

  /**
   * Дата блокировки С
   * @format date-time
   */
  From?: string;

  /**
   * Дата блокировки ПО
   * @format date-time
   */
  To?: string;

  /** Все/Активные/Неактивные */
  Deleted?: boolean;

  /**
   * Индекс страницы
   * @format int32
   */
  PageIndex?: number;

  /**
   * Количество запрашиваемых сущностей
   * @format int32
   */
  PageSize?: number;
}

export interface ManageUsersBlockCreateParams {
  comment: string;

  /** @format int32 */
  userId: number;
}

export interface ManageTagListParams {
  /** Возвращает тег по подстроке в имени или алисе */
  Term?: string;

  /** Продуктовый заголовок тега */
  Title?: string;

  /** Возвращает теги, соответствующие указанному продуктовому тегу */
  ServiceTag?:
    | 'unknown'
    | 'serviceLevel'
    | 'credits'
    | 'mortgage'
    | 'autocredits'
    | 'creditCards'
    | 'currencyExchange'
    | 'casco'
    | 'osago'
    | 'dsago'
    | 'homeInsurance'
    | 'travelInsurance'
    | 'moneyOrder'
    | 'greenCard'
    | 'priceQuality'
    | 'overallImpression'
    | 'aboutBuyingCarsFromAutoDealers'
    | 'microcredits'
    | 'debitCards'
    | 'remoteService'
    | 'businessDeposit'
    | 'businessCredits'
    | 'creditRefinancing'
    | 'investmentInsurance'
    | 'businessInsurance'
    | 'lifeInsurance'
    | 'responsibilityInsurance'
    | 'financialRiskInsurance'
    | 'pensionInsurance'
    | 'healthInsurance'
    | 'mortgageInsurance'
    | 'mortgageRefinancing'
    | 'businessRko'
    | 'factoring'
    | 'sportsInsurance'
    | 'acquiring'
    | 'business'
    | 'данные'
    | 'typeProgramming'
    | 'typeDesign'
    | 'typeManagement'
    | 'typeMarketing'
    | 'typeFinance'
    | 'typeAnalytics'
    | 'typeSoftSkills'
    | 'typeCreativity'
    | 'typeBeauty'
    | 'typeLanguage'
    | 'typeApplication'
    | 'sdelki'
    | 'otkrutie_scheta'
    | '654321'
    | '789'
    | '1547244'
    | '5723864'
    | 'Decor'
    | 'ApplicationAndWebsite'
    | 'ServiceErrors'
    | 'Interface'
    | 'Convenience'
    | 'Conditions'
    | 'techpodderzhka'
    | 'bonuses'
    | 'bets-variety '
    | 'Teachers'
    | 'Location'
    | 'Hostel'
    | 'Food'
    | 'other'
    | 'kursy'
    | 'Training_programs'
    | 'Payment'
    | 'Appp'
    | 'Insurance'
    | 'learning_process'
    | 'Support'
    | 'Vuvod_sredstv'
    | 'Uslovia_i_tarif'
    | 'Duration'
    | 'Functional'
    | 'Price'
    | 'Education'
    | 'egeOge'
    | 'dasdas'
    | 'asdsaads'
    | 'leasing'
    | 'biznesRegistration'
    | 'biznesNaMarketpleysakh'
    | 'bukhgalteriyaDlyaBiznesa'
    | 'savings'
    | '1234'
    | ' uslugaeda'
    | 'super-eda'
    | 'superedaeda'
    | '999367'
    | '9546738'
    | 'quality'
    | 'npf-fiz-uslugaa'
    | 'quality-of-food'
    | 'delivery'
    | 'package'
    | 'menu'
    | 'loyalty-program'
    | 'kittens'
    | 'strakhovaniyeOtUkusaKleshcha'
    | 'stavki';

  /**
   * Возвращает теги определенного отзыва
   * @format int32
   */
  ReviewId?: number;

  /** Возвращает либо позитивные, либо негативные теги. Если null - вернет все. */
  IsPositive?: boolean;

  /** Вернуть только валидные теги, или вместе с удалеными */
  PublicOnly?: boolean;

  /**
   * Индекс страницы
   * @format int32
   */
  PageIndex?: number;

  /**
   * Количество запрашиваемых сущностей
   * @format int32
   */
  PageSize?: number;
}

export interface ManageTagProductTagListParams {
  /** наименование тега, ищет по подстроке */
  name?: string;
}

export interface BackofficeRatingListParams {
  OrganizationType?: SravniOrganizationsSharedReviewObjectType;
  OrganizationId?: string;
  ServiceTags?: (
    | 'unknown'
    | 'serviceLevel'
    | 'credits'
    | 'mortgage'
    | 'autocredits'
    | 'creditCards'
    | 'currencyExchange'
    | 'casco'
    | 'osago'
    | 'dsago'
    | 'homeInsurance'
    | 'travelInsurance'
    | 'moneyOrder'
    | 'greenCard'
    | 'priceQuality'
    | 'overallImpression'
    | 'aboutBuyingCarsFromAutoDealers'
    | 'microcredits'
    | 'debitCards'
    | 'remoteService'
    | 'businessDeposit'
    | 'businessCredits'
    | 'creditRefinancing'
    | 'investmentInsurance'
    | 'businessInsurance'
    | 'lifeInsurance'
    | 'responsibilityInsurance'
    | 'financialRiskInsurance'
    | 'pensionInsurance'
    | 'healthInsurance'
    | 'mortgageInsurance'
    | 'mortgageRefinancing'
    | 'businessRko'
    | 'factoring'
    | 'sportsInsurance'
    | 'acquiring'
    | 'business'
    | 'данные'
    | 'typeProgramming'
    | 'typeDesign'
    | 'typeManagement'
    | 'typeMarketing'
    | 'typeFinance'
    | 'typeAnalytics'
    | 'typeSoftSkills'
    | 'typeCreativity'
    | 'typeBeauty'
    | 'typeLanguage'
    | 'typeApplication'
    | 'sdelki'
    | 'otkrutie_scheta'
    | '654321'
    | '789'
    | '1547244'
    | '5723864'
    | 'Decor'
    | 'ApplicationAndWebsite'
    | 'ServiceErrors'
    | 'Interface'
    | 'Convenience'
    | 'Conditions'
    | 'techpodderzhka'
    | 'bonuses'
    | 'bets-variety '
    | 'Teachers'
    | 'Location'
    | 'Hostel'
    | 'Food'
    | 'other'
    | 'kursy'
    | 'Training_programs'
    | 'Payment'
    | 'Appp'
    | 'Insurance'
    | 'learning_process'
    | 'Support'
    | 'Vuvod_sredstv'
    | 'Uslovia_i_tarif'
    | 'Duration'
    | 'Functional'
    | 'Price'
    | 'Education'
    | 'egeOge'
    | 'dasdas'
    | 'asdsaads'
    | 'leasing'
    | 'biznesRegistration'
    | 'biznesNaMarketpleysakh'
    | 'bukhgalteriyaDlyaBiznesa'
    | 'savings'
    | '1234'
    | ' uslugaeda'
    | 'super-eda'
    | 'superedaeda'
    | '999367'
    | '9546738'
    | 'quality'
    | 'npf-fiz-uslugaa'
    | 'quality-of-food'
    | 'delivery'
    | 'package'
    | 'menu'
    | 'loyalty-program'
    | 'kittens'
    | 'strakhovaniyeOtUkusaKleshcha'
    | 'stavki'
  )[];

  /** Список конкретных продуктов, по которым нужно вернуть рейтинг */
  SpecificProductsIds?: string[];

  /**
   * Минимальное кол-во отзывов, которое должно быть у компании для того, чтобы сервис вернул ее рейтинг
   * @format int32
   */
  MinReviewsCount?: number;

  /**
   * Идентификатор геолокации
   * @format int32
   */
  LocationId?: number;

  /**
   * Идентификатор геолокации (новый формат)
   * @format int32
   */
  LocationGarId?: number;

  /** Тип агрегации рейтинга */
  RatingType?: SravniReviewsEnumsRatingType;

  /** Тип подаггрегации рейтинга в разрезах локаций */
  LocationRatingType?: SravniReviewsEnumsLocationRatingType;

  /** Тип отзыва - юрик/физикad */
  IsLegal?: boolean;

  /**
   * Дата расчета
   * @format date-time
   */
  From?: string;

  /** @format date-time */
  To?: string;

  /**
   * Минимальное кол-во отзывов с подтверждённой оценкой включительно
   * @format int32
   */
  MinApprovedCount?: number;

  /**
   * Индекс страницы
   * @format int32
   */
  PageIndex?: number;

  /**
   * Количество запрашиваемых сущностей
   * @format int32
   */
  PageSize?: number;
}

export interface ModeratorToOrganizationsDeleteParams {
  /** @format int32 */
  id?: number;
}

export interface RatingListParams {
  OrganizationType?: SravniOrganizationsSharedReviewObjectType;
  OrganizationId?: string;
  ServiceTags?: (
    | 'unknown'
    | 'serviceLevel'
    | 'credits'
    | 'mortgage'
    | 'autocredits'
    | 'creditCards'
    | 'currencyExchange'
    | 'casco'
    | 'osago'
    | 'dsago'
    | 'homeInsurance'
    | 'travelInsurance'
    | 'moneyOrder'
    | 'greenCard'
    | 'priceQuality'
    | 'overallImpression'
    | 'aboutBuyingCarsFromAutoDealers'
    | 'microcredits'
    | 'debitCards'
    | 'remoteService'
    | 'businessDeposit'
    | 'businessCredits'
    | 'creditRefinancing'
    | 'investmentInsurance'
    | 'businessInsurance'
    | 'lifeInsurance'
    | 'responsibilityInsurance'
    | 'financialRiskInsurance'
    | 'pensionInsurance'
    | 'healthInsurance'
    | 'mortgageInsurance'
    | 'mortgageRefinancing'
    | 'businessRko'
    | 'factoring'
    | 'sportsInsurance'
    | 'acquiring'
    | 'business'
    | 'данные'
    | 'typeProgramming'
    | 'typeDesign'
    | 'typeManagement'
    | 'typeMarketing'
    | 'typeFinance'
    | 'typeAnalytics'
    | 'typeSoftSkills'
    | 'typeCreativity'
    | 'typeBeauty'
    | 'typeLanguage'
    | 'typeApplication'
    | 'sdelki'
    | 'otkrutie_scheta'
    | '654321'
    | '789'
    | '1547244'
    | '5723864'
    | 'Decor'
    | 'ApplicationAndWebsite'
    | 'ServiceErrors'
    | 'Interface'
    | 'Convenience'
    | 'Conditions'
    | 'techpodderzhka'
    | 'bonuses'
    | 'bets-variety '
    | 'Teachers'
    | 'Location'
    | 'Hostel'
    | 'Food'
    | 'other'
    | 'kursy'
    | 'Training_programs'
    | 'Payment'
    | 'Appp'
    | 'Insurance'
    | 'learning_process'
    | 'Support'
    | 'Vuvod_sredstv'
    | 'Uslovia_i_tarif'
    | 'Duration'
    | 'Functional'
    | 'Price'
    | 'Education'
    | 'egeOge'
    | 'dasdas'
    | 'asdsaads'
    | 'leasing'
    | 'biznesRegistration'
    | 'biznesNaMarketpleysakh'
    | 'bukhgalteriyaDlyaBiznesa'
    | 'savings'
    | '1234'
    | ' uslugaeda'
    | 'super-eda'
    | 'superedaeda'
    | '999367'
    | '9546738'
    | 'quality'
    | 'npf-fiz-uslugaa'
    | 'quality-of-food'
    | 'delivery'
    | 'package'
    | 'menu'
    | 'loyalty-program'
    | 'kittens'
    | 'strakhovaniyeOtUkusaKleshcha'
    | 'stavki'
  )[];

  /** Список конкретных продуктов, по которым нужно вернуть рейтинг */
  SpecificProductsIds?: string[];

  /**
   * Минимальное кол-во отзывов, которое должно быть у компании для того, чтобы сервис вернул ее рейтинг
   * @format int32
   */
  MinReviewsCount?: number;

  /**
   * Идентификатор геолокации
   * @format int32
   */
  LocationId?: number;

  /**
   * Идентификатор геолокации (новый формат)
   * @format int32
   */
  LocationGarId?: number;

  /** Тип агрегации рейтинга */
  RatingType?: SravniReviewsEnumsRatingType;

  /** Тип подаггрегации рейтинга в разрезах локаций */
  LocationRatingType?: SravniReviewsEnumsLocationRatingType;

  /** Тип отзыва - юрик/физикad */
  IsLegal?: boolean;

  /**
   * Дата расчета
   * @format date-time
   */
  From?: string;

  /** @format date-time */
  To?: string;

  /**
   * Минимальное кол-во отзывов с подтверждённой оценкой включительно
   * @format int32
   */
  MinApprovedCount?: number;

  /**
   * Индекс страницы
   * @format int32
   */
  PageIndex?: number;

  /**
   * Количество запрашиваемых сущностей
   * @format int32
   */
  PageSize?: number;
}

export interface ReviewStatsListParams {
  organizationType?: SravniOrganizationsSharedReviewObjectType;
  organizationId?: string;

  /** Код услуги */
  reviewTag?: string;
}

export interface ReviewSeoStatsListParams {
  organizationType?: SravniOrganizationsSharedReviewObjectType;
  organizationId?: string;

  /** Код или алиас услуги */
  reviewTag?: string;
  specificProductId?: string;
}

export interface SravniCustomersRatingListParams {
  /** Тип организации */
  OrganizationType?: SravniOrganizationsSharedReviewObjectType;

  /** Идентификатор организации */
  OrganizationId?: string;

  /**
   * Дата расчета
   * @format date-time
   */
  OnDate?: string;

  /** Услуга */
  ServiceTag?:
    | 'unknown'
    | 'serviceLevel'
    | 'credits'
    | 'mortgage'
    | 'autocredits'
    | 'creditCards'
    | 'currencyExchange'
    | 'casco'
    | 'osago'
    | 'dsago'
    | 'homeInsurance'
    | 'travelInsurance'
    | 'moneyOrder'
    | 'greenCard'
    | 'priceQuality'
    | 'overallImpression'
    | 'aboutBuyingCarsFromAutoDealers'
    | 'microcredits'
    | 'debitCards'
    | 'remoteService'
    | 'businessDeposit'
    | 'businessCredits'
    | 'creditRefinancing'
    | 'investmentInsurance'
    | 'businessInsurance'
    | 'lifeInsurance'
    | 'responsibilityInsurance'
    | 'financialRiskInsurance'
    | 'pensionInsurance'
    | 'healthInsurance'
    | 'mortgageInsurance'
    | 'mortgageRefinancing'
    | 'businessRko'
    | 'factoring'
    | 'sportsInsurance'
    | 'acquiring'
    | 'business'
    | 'данные'
    | 'typeProgramming'
    | 'typeDesign'
    | 'typeManagement'
    | 'typeMarketing'
    | 'typeFinance'
    | 'typeAnalytics'
    | 'typeSoftSkills'
    | 'typeCreativity'
    | 'typeBeauty'
    | 'typeLanguage'
    | 'typeApplication'
    | 'sdelki'
    | 'otkrutie_scheta'
    | '654321'
    | '789'
    | '1547244'
    | '5723864'
    | 'Decor'
    | 'ApplicationAndWebsite'
    | 'ServiceErrors'
    | 'Interface'
    | 'Convenience'
    | 'Conditions'
    | 'techpodderzhka'
    | 'bonuses'
    | 'bets-variety '
    | 'Teachers'
    | 'Location'
    | 'Hostel'
    | 'Food'
    | 'other'
    | 'kursy'
    | 'Training_programs'
    | 'Payment'
    | 'Appp'
    | 'Insurance'
    | 'learning_process'
    | 'Support'
    | 'Vuvod_sredstv'
    | 'Uslovia_i_tarif'
    | 'Duration'
    | 'Functional'
    | 'Price'
    | 'Education'
    | 'egeOge'
    | 'dasdas'
    | 'asdsaads'
    | 'leasing'
    | 'biznesRegistration'
    | 'biznesNaMarketpleysakh'
    | 'bukhgalteriyaDlyaBiznesa'
    | 'savings'
    | '1234'
    | ' uslugaeda'
    | 'super-eda'
    | 'superedaeda'
    | '999367'
    | '9546738'
    | 'quality'
    | 'npf-fiz-uslugaa'
    | 'quality-of-food'
    | 'delivery'
    | 'package'
    | 'menu'
    | 'loyalty-program'
    | 'kittens'
    | 'strakhovaniyeOtUkusaKleshcha'
    | 'stavki';

  /**
   * Конкретный продукт
   * Unknown чтобы исключить разрезы по продуктам
   */
  SpecificProductId?: string;

  /**
   * Идентификатор геолокации
   * @format int32
   */
  LocationId?: number;

  /**
   * Идентификатор геолокации (новый формат)
   * @format int32
   */
  LocationGarId?: number;

  /** Тип агрегации рейтинга */
  RatingType?: SravniReviewsEnumsRatingType;

  /** Тип подаггрегации рейтинга в разрезах локаций */
  LocationRatingType?: SravniReviewsEnumsLocationRatingType;

  /** Тип отзыва - физик/юрик */
  IsLegal?: boolean;

  /**
   * Минимальное кол-во отзывов с подтверждённой оценкой включительно
   * @format int32
   */
  MinApprovedCount?: number;

  /**
   * Индекс страницы
   * @format int32
   */
  PageIndex?: number;

  /**
   * Количество запрашиваемых сущностей
   * @format int32
   */
  PageSize?: number;
}

export interface RatingForInterestingOffersListParams {
  /** Идентификаторы конкретных продуктов по которым ищем рейтинги */
  SpecificProductsIds?: string[];
}

export interface ReadedCommentsUnreadedCommentsListParams {
  /** Идентификатор отзыва */
  ReviewIds?: number[];
}

export interface ReadedCommentsLastReadedCommentsListParams {
  /** Идентификаторы отзывов */
  ReviewIds?: number[];
}

export interface ReportsExportReviewsListParams {
  /** Псевдоним автора */
  AuthorName?: string;

  /** Фамилия автора */
  AuthorLastName?: string;

  /** email автора */
  AuthorEmail?: string;

  /** Телефон */
  AuthorPhone?: string;

  /** IP пользователя */
  Ip?: string;

  /** FingerPrint пользователя */
  FingerPrint?: string;

  /** Фильтрация по мылу взявшего в модерацию */
  ModeratorEmail?: string;

  /**
   * null = не учитывает фильтр
   * true = отзывы с решенной проблемой
   * false = отзывы с нерешенной проблемой
   */
  HaveDocument?: boolean;

  /** Имя рекламного источника */
  UtmSource?: string;

  /** Имя рекламной компании */
  UtmCampaign?: string;

  /** Тип трафика */
  UtmMedium?: string;

  /** Признак того, что отзыв был оставлен клиентом Сравни */
  IsSravniClient?: boolean;

  /** Признак того, что отзыв был оставлен о Сравни */
  IsAboutSravni?: boolean;

  /** Поиск по данным браузера */
  UserAgent?: string;

  /** Поиск по хешированному номеру телефона */
  HashedPhoneNumber?: string;

  /** Поиск по типу спаршенного отзыва */
  ParsedReviewType?: SravniReviewsEnumsParsedReviewType;

  /** Тип удаления отзыва */
  DeleteReason?: SravniReviewsEnumsDeleteReason;

  /** Признак того, что отзыв был удален пользователем */
  IsDeleteByUser?: boolean;

  /**
   * дата с
   * @format date-time
   */
  From?: string;

  /**
   * дата по
   * @format date-time
   */
  To?: string;

  /** Мыльник модератора к организации */
  ModeratorToOrganizationEmail?: string;

  /** Отзывы  на контроле */
  FollowUpOnly?: boolean;

  /** Тип предмета отзыва */
  ReviewObjectType?: SravniOrganizationsSharedReviewObjectType;

  /** Тип организации в массиве */
  ReviewObjectTypes?: SravniOrganizationsSharedReviewObjectType[];

  /** Id предмета отзыва */
  ReviewObjectId?: string;

  /** Id предметов отзыва */
  ReviewObjectIds?: string[];

  /** Порядок сортировки отзывов */
  OrderBy?: SravniReviewsEnumsReviewOrder;

  /** Фильтрация отзывов */
  FilterBy?: SravniReviewsEnumsReviewFilter;

  /** Фильтрация по зачтённой оценке */
  Rated?: SravniReviewsEnumsReviewRate[];

  /** Фильтрация по проверяющейся оценке */
  CheckingRated?: SravniReviewsEnumsReviewRate[];

  /**
   * Фильтрация по идентификаторам векторов выжимок
   * От 0 до 20-ти
   */
  SqueezesVectorIds?: number[];

  /** Фильтрация по тэгу, если нужно. */
  Tag?:
    | 'unknown'
    | 'serviceLevel'
    | 'credits'
    | 'mortgage'
    | 'autocredits'
    | 'creditCards'
    | 'currencyExchange'
    | 'casco'
    | 'osago'
    | 'dsago'
    | 'homeInsurance'
    | 'travelInsurance'
    | 'moneyOrder'
    | 'greenCard'
    | 'priceQuality'
    | 'overallImpression'
    | 'aboutBuyingCarsFromAutoDealers'
    | 'microcredits'
    | 'debitCards'
    | 'remoteService'
    | 'businessDeposit'
    | 'businessCredits'
    | 'creditRefinancing'
    | 'investmentInsurance'
    | 'businessInsurance'
    | 'lifeInsurance'
    | 'responsibilityInsurance'
    | 'financialRiskInsurance'
    | 'pensionInsurance'
    | 'healthInsurance'
    | 'mortgageInsurance'
    | 'mortgageRefinancing'
    | 'businessRko'
    | 'factoring'
    | 'sportsInsurance'
    | 'acquiring'
    | 'business'
    | 'данные'
    | 'typeProgramming'
    | 'typeDesign'
    | 'typeManagement'
    | 'typeMarketing'
    | 'typeFinance'
    | 'typeAnalytics'
    | 'typeSoftSkills'
    | 'typeCreativity'
    | 'typeBeauty'
    | 'typeLanguage'
    | 'typeApplication'
    | 'sdelki'
    | 'otkrutie_scheta'
    | '654321'
    | '789'
    | '1547244'
    | '5723864'
    | 'Decor'
    | 'ApplicationAndWebsite'
    | 'ServiceErrors'
    | 'Interface'
    | 'Convenience'
    | 'Conditions'
    | 'techpodderzhka'
    | 'bonuses'
    | 'bets-variety '
    | 'Teachers'
    | 'Location'
    | 'Hostel'
    | 'Food'
    | 'other'
    | 'kursy'
    | 'Training_programs'
    | 'Payment'
    | 'Appp'
    | 'Insurance'
    | 'learning_process'
    | 'Support'
    | 'Vuvod_sredstv'
    | 'Uslovia_i_tarif'
    | 'Duration'
    | 'Functional'
    | 'Price'
    | 'Education'
    | 'egeOge'
    | 'dasdas'
    | 'asdsaads'
    | 'leasing'
    | 'biznesRegistration'
    | 'biznesNaMarketpleysakh'
    | 'bukhgalteriyaDlyaBiznesa'
    | 'savings'
    | '1234'
    | ' uslugaeda'
    | 'super-eda'
    | 'superedaeda'
    | '999367'
    | '9546738'
    | 'quality'
    | 'npf-fiz-uslugaa'
    | 'quality-of-food'
    | 'delivery'
    | 'package'
    | 'menu'
    | 'loyalty-program'
    | 'kittens'
    | 'strakhovaniyeOtUkusaKleshcha'
    | 'stavki';

  /** Фильтрация по тэгу группы. */
  GroupTag?:
    | 'SAD'
    | 'test'
    | 'ыфввыф'
    | '333333333'
    | 'Decor'
    | 'Conditions'
    | 'bets-variety '
    | 'asdsaads'
    | 'strakhovaniyeOtUkusaKleshcha'
    | 'business'
    | 'bukhgalteriyaDlyaBiznesa'
    | 'other'
    | 'kursy'
    | 'Training_programs'
    | 'Payment'
    | 'Appp'
    | 'Insurance'
    | 'learning_process'
    | 'Support'
    | 'Vuvod_sredstv'
    | 'Uslovia_i_tarif'
    | 'Duration'
    | 'Functional'
    | 'Price'
    | 'Education'
    | '333'
    | '426822347';

  /** Включать удаленные */
  Deleted?: boolean;

  /** Заголовок/часть заголовка */
  Title?: string;

  /** Текст/часть текста */
  Text?: string;

  /** Роут локации отзыва */
  LocationRoute?: string;

  /** Роут локации отзыва нового формата */
  LocationGarRoute?: string;

  /**
   * id локации
   * @format int32
   */
  LocationId?: number;

  /**
   * GarId локации
   * @format int32
   */
  LocationGarId?: number;

  /** Статус оценки */
  RateStatus?: SravniReviewsEnumsReviewRateStatus;

  /**
   * Id отзыва (для списка комментариев)
   * @format int32
   */
  ReviewId?: number;

  /** статус комментария //todo: поправить нейминг */
  ReviewStatus?: SravniReviewsEnumsReviewStatus;

  /** статус наличия ответа от компании */
  HasCompanyResponse?: boolean;

  /** Id продукта любой витрины */
  SpecificProductId?: string;

  /** true - отзывы юриков; false - отзывы физиков; null - все отзывы */
  IsLegal?: boolean;

  /** true - есть персональные данные пользователя; false - нет персональных данных пользователя; null - все отзывы */
  HasPersonalData?: boolean;

  /** Предпочитать MongoID вместо INT */
  NewIds?: boolean;

  /** Возвращает по одному отзыву (если есть) на организацию */
  UniqueOnly?: boolean;

  /** Включать лайки? (не фильтр) */
  WithVotes?: boolean;

  /** Идентификаторы отзывов для поиска по айдишникам */
  ReviewIds?: number[];

  /** Идентификаторы пользователей */
  UserIds?: number[];

  /**
   * Индекс страницы
   * @format int32
   */
  PageIndex?: number;

  /**
   * Количество запрашиваемых сущностей
   * @format int32
   */
  PageSize?: number;
}

export interface ReportsExportStatsDetailedListParams {
  organizationId?: string;

  /**
   * Дата начала периода
   * @format date-time
   */
  From?: string;

  /**
   * Дата окончания периода (включительно)
   * @format date-time
   */
  To?: string;

  /** Тип группировки */
  GroupingType?: SravniReviewsEnumsReputationGroupingType;

  /** Тег продукта, если не указан или unknown - собирает общую статистику */
  ProductTag?: string;

  /**
   * Индекс страницы
   * @format int32
   */
  PageIndex?: number;

  /**
   * Количество запрашиваемых сущностей
   * @format int32
   */
  PageSize?: number;
}

export interface ReportsStatsBusinessListParams {
  ReviewTag?: string;
  OrganizationType?: SravniOrganizationsSharedReviewObjectType;
  Interval?: SravniReviewsEnumsDateInterval;

  /** @format int32 */
  IntervalAmount?: number;
  ReviewRates?: number[];
  GroupByOrganizations?: boolean;
  EventTypes?: SravniReviewsEnumsActivityEventType[];
  OrganizationIds?: string[];

  /** @format date-time */
  From?: string;

  /** @format date-time */
  To?: string;
}

export interface ReportsStatsRatesListParams {
  ReviewTag?: string;
  OrganizationType?: SravniOrganizationsSharedReviewObjectType;
  Interval?: SravniReviewsEnumsDateInterval;

  /** @format int32 */
  IntervalAmount?: number;
  ReviewRates?: number[];
  GroupByOrganizations?: boolean;
  EventTypes?: SravniReviewsEnumsActivityEventType[];
  OrganizationIds?: string[];

  /** @format date-time */
  From?: string;

  /** @format date-time */
  To?: string;
}

export interface ReportsStatsActivityListParams {
  UserIds?: number[];
  EventTypes?: SravniReviewsEnumsActivityEventType[];
  OrganizationIds?: string[];

  /** @format date-time */
  From?: string;

  /** @format date-time */
  To?: string;
}

export interface ReportsStatsRawReviewListParams {
  OrganizationIds?: string[];
  OrganizationTypes?: SravniOrganizationsSharedReviewObjectType[];

  /** @format date-time */
  From?: string;

  /** @format date-time */
  To?: string;
}

export interface OrganizationUsersListParams {
  OrganizationId?: string;

  /** @format int32 */
  UserId?: number;
  Deleted?: boolean;

  /**
   * Индекс страницы
   * @format int32
   */
  PageIndex?: number;

  /**
   * Количество запрашиваемых сущностей
   * @format int32
   */
  PageSize?: number;
}

export interface ReputationBestOrganizationsListParams {
  /** Тип организации */
  ReviewObjectType?: SravniOrganizationsSharedReviewObjectType;

  /**
   * Дата начала периода
   * @format date-time
   */
  From?: string;

  /**
   * Дата окончания периода (включительно)
   * @format date-time
   */
  To?: string;
}

export interface ReputationDetailParams {
  /**
   * Дата начала периода
   * @format date-time
   */
  From?: string;

  /**
   * Дата окончания периода (включительно)
   * @format date-time
   */
  To?: string;
  organizationId: string;
}

export interface ReputationPositionDetailParams {
  organizationType?: SravniOrganizationsSharedReviewObjectType;
  organizationId: string;
}

export interface ReputationStatsDetailParams {
  /** Тип группировки */
  GroupingType?: SravniReviewsEnumsReputationGroupingType;

  /** Тег продукта, если не указан или unknown - собирает общую статистику */
  ProductTag?: string;

  /**
   * Дата начала периода
   * @format date-time
   */
  From?: string;

  /**
   * Дата окончания периода (включительно)
   * @format date-time
   */
  To?: string;
  organizationId: string;
}

export interface ReputationStatsPerformanceOverviewDetailParams {
  /** Тег продукта, если не указан или unknown - собирает общую статистику */
  ProductTag?: string;

  /**
   * Дата начала периода
   * @format date-time
   */
  From?: string;

  /**
   * Дата окончания периода (включительно)
   * @format date-time
   */
  To?: string;
  organizationId: string;
}

export interface ReputationStatsCompanyResponseDetailParams {
  /** Тег продукта, если не указан или unknown - собирает общую статистику */
  ProductTag?: string;

  /**
   * Дата начала периода
   * @format date-time
   */
  From?: string;

  /**
   * Дата окончания периода (включительно)
   * @format date-time
   */
  To?: string;
  organizationId: string;
}

export interface ReputationStatsDetailedDetailParams {
  /**
   * Дата начала периода
   * @format date-time
   */
  From?: string;

  /**
   * Дата окончания периода (включительно)
   * @format date-time
   */
  To?: string;

  /** Тип группировки */
  GroupingType?: SravniReviewsEnumsReputationGroupingType;

  /** Тег продукта, если не указан или unknown - собирает общую статистику */
  ProductTag?: string;

  /**
   * Индекс страницы
   * @format int32
   */
  PageIndex?: number;

  /**
   * Количество запрашиваемых сущностей
   * @format int32
   */
  PageSize?: number;
  organizationId: string;
}

export interface ReputationStatsCsvDetailParams {
  /** Список полей для выгрузки, порядок соответствует порядку переданному списку */
  Fields?: SravniReviewsEnumsReputationDetailField[];

  /**
   * Дата начала периода
   * @format date-time
   */
  From?: string;

  /**
   * Дата окончания периода (включительно)
   * @format date-time
   */
  To?: string;

  /** Тип группировки */
  GroupingType?: SravniReviewsEnumsReputationGroupingType;

  /** Тег продукта, если не указан или unknown - собирает общую статистику */
  ProductTag?: string;

  /**
   * Индекс страницы
   * @format int32
   */
  PageIndex?: number;

  /**
   * Количество запрашиваемых сущностей
   * @format int32
   */
  PageSize?: number;
  organizationId: string;
}

export interface ReviewsAdditionalInfoSchemesListParams {
  /** Идентификатор организации */
  OrganizationId?: string;

  /** Тип организации */
  OrganizationType?: SravniOrganizationsSharedReviewObjectType;

  /** Услуга */
  ServiceTag?:
    | 'unknown'
    | 'serviceLevel'
    | 'credits'
    | 'mortgage'
    | 'autocredits'
    | 'creditCards'
    | 'currencyExchange'
    | 'casco'
    | 'osago'
    | 'dsago'
    | 'homeInsurance'
    | 'travelInsurance'
    | 'moneyOrder'
    | 'greenCard'
    | 'priceQuality'
    | 'overallImpression'
    | 'aboutBuyingCarsFromAutoDealers'
    | 'microcredits'
    | 'debitCards'
    | 'remoteService'
    | 'businessDeposit'
    | 'businessCredits'
    | 'creditRefinancing'
    | 'investmentInsurance'
    | 'businessInsurance'
    | 'lifeInsurance'
    | 'responsibilityInsurance'
    | 'financialRiskInsurance'
    | 'pensionInsurance'
    | 'healthInsurance'
    | 'mortgageInsurance'
    | 'mortgageRefinancing'
    | 'businessRko'
    | 'factoring'
    | 'sportsInsurance'
    | 'acquiring'
    | 'business'
    | 'данные'
    | 'typeProgramming'
    | 'typeDesign'
    | 'typeManagement'
    | 'typeMarketing'
    | 'typeFinance'
    | 'typeAnalytics'
    | 'typeSoftSkills'
    | 'typeCreativity'
    | 'typeBeauty'
    | 'typeLanguage'
    | 'typeApplication'
    | 'sdelki'
    | 'otkrutie_scheta'
    | '654321'
    | '789'
    | '1547244'
    | '5723864'
    | 'Decor'
    | 'ApplicationAndWebsite'
    | 'ServiceErrors'
    | 'Interface'
    | 'Convenience'
    | 'Conditions'
    | 'techpodderzhka'
    | 'bonuses'
    | 'bets-variety '
    | 'Teachers'
    | 'Location'
    | 'Hostel'
    | 'Food'
    | 'other'
    | 'kursy'
    | 'Training_programs'
    | 'Payment'
    | 'Appp'
    | 'Insurance'
    | 'learning_process'
    | 'Support'
    | 'Vuvod_sredstv'
    | 'Uslovia_i_tarif'
    | 'Duration'
    | 'Functional'
    | 'Price'
    | 'Education'
    | 'egeOge'
    | 'dasdas'
    | 'asdsaads'
    | 'leasing'
    | 'biznesRegistration'
    | 'biznesNaMarketpleysakh'
    | 'bukhgalteriyaDlyaBiznesa'
    | 'savings'
    | '1234'
    | ' uslugaeda'
    | 'super-eda'
    | 'superedaeda'
    | '999367'
    | '9546738'
    | 'quality'
    | 'npf-fiz-uslugaa'
    | 'quality-of-food'
    | 'delivery'
    | 'package'
    | 'menu'
    | 'loyalty-program'
    | 'kittens'
    | 'strakhovaniyeOtUkusaKleshcha'
    | 'stavki';
  PublicOnly?: boolean;

  /**
   * Индекс страницы
   * @format int32
   */
  PageIndex?: number;

  /**
   * Количество запрашиваемых сущностей
   * @format int32
   */
  PageSize?: number;
}

export interface ReviewsAdditionalInfoSchemeListParams {
  /** Тип организации */
  OrganizationType?: SravniOrganizationsSharedReviewObjectType;

  /** Идентификатор организации */
  OrganizationId?: string;

  /** Услуга */
  ProductTag?: string;
}

export interface ReviewRequestsIncrementRequestByUserPartialUpdateParams {
  /**
   * Идентификатор Запроса на создание отзыва (не пользователя)
   * @format int32
   * @min 1
   * @max 2147483647
   */
  id?: number;
}

export interface ReviewRequestsRemoveByUserDeleteParams {
  /**
   * Идентификатор Запроса на создание отзыва (не пользователя)
   * @format int32
   * @min 1
   * @max 2147483647
   */
  id?: number;
}

export interface ReviewsListParams {
  /** Тип предмета отзыва */
  ReviewObjectType?: SravniOrganizationsSharedReviewObjectType;

  /** Тип организации в массиве */
  ReviewObjectTypes?: SravniOrganizationsSharedReviewObjectType[];

  /** Id предмета отзыва */
  ReviewObjectId?: string;

  /** Id предметов отзыва */
  ReviewObjectIds?: string[];

  /** Порядок сортировки отзывов */
  OrderBy?: SravniReviewsEnumsReviewOrder;

  /** Фильтрация отзывов */
  FilterBy?: SravniReviewsEnumsReviewFilter;

  /** Фильтрация по зачтённой оценке */
  Rated?: SravniReviewsEnumsReviewRate[];

  /** Фильтрация по проверяющейся оценке */
  CheckingRated?: SravniReviewsEnumsReviewRate[];

  /**
   * Фильтрация по идентификаторам векторов выжимок
   * От 0 до 20-ти
   */
  SqueezesVectorIds?: number[];

  /** Фильтрация по тэгу, если нужно. */
  Tag?:
    | 'unknown'
    | 'serviceLevel'
    | 'credits'
    | 'mortgage'
    | 'autocredits'
    | 'creditCards'
    | 'currencyExchange'
    | 'casco'
    | 'osago'
    | 'dsago'
    | 'homeInsurance'
    | 'travelInsurance'
    | 'moneyOrder'
    | 'greenCard'
    | 'priceQuality'
    | 'overallImpression'
    | 'aboutBuyingCarsFromAutoDealers'
    | 'microcredits'
    | 'debitCards'
    | 'remoteService'
    | 'businessDeposit'
    | 'businessCredits'
    | 'creditRefinancing'
    | 'investmentInsurance'
    | 'businessInsurance'
    | 'lifeInsurance'
    | 'responsibilityInsurance'
    | 'financialRiskInsurance'
    | 'pensionInsurance'
    | 'healthInsurance'
    | 'mortgageInsurance'
    | 'mortgageRefinancing'
    | 'businessRko'
    | 'factoring'
    | 'sportsInsurance'
    | 'acquiring'
    | 'business'
    | 'данные'
    | 'typeProgramming'
    | 'typeDesign'
    | 'typeManagement'
    | 'typeMarketing'
    | 'typeFinance'
    | 'typeAnalytics'
    | 'typeSoftSkills'
    | 'typeCreativity'
    | 'typeBeauty'
    | 'typeLanguage'
    | 'typeApplication'
    | 'sdelki'
    | 'otkrutie_scheta'
    | '654321'
    | '789'
    | '1547244'
    | '5723864'
    | 'Decor'
    | 'ApplicationAndWebsite'
    | 'ServiceErrors'
    | 'Interface'
    | 'Convenience'
    | 'Conditions'
    | 'techpodderzhka'
    | 'bonuses'
    | 'bets-variety '
    | 'Teachers'
    | 'Location'
    | 'Hostel'
    | 'Food'
    | 'other'
    | 'kursy'
    | 'Training_programs'
    | 'Payment'
    | 'Appp'
    | 'Insurance'
    | 'learning_process'
    | 'Support'
    | 'Vuvod_sredstv'
    | 'Uslovia_i_tarif'
    | 'Duration'
    | 'Functional'
    | 'Price'
    | 'Education'
    | 'egeOge'
    | 'dasdas'
    | 'asdsaads'
    | 'leasing'
    | 'biznesRegistration'
    | 'biznesNaMarketpleysakh'
    | 'bukhgalteriyaDlyaBiznesa'
    | 'savings'
    | '1234'
    | ' uslugaeda'
    | 'super-eda'
    | 'superedaeda'
    | '999367'
    | '9546738'
    | 'quality'
    | 'npf-fiz-uslugaa'
    | 'quality-of-food'
    | 'delivery'
    | 'package'
    | 'menu'
    | 'loyalty-program'
    | 'kittens'
    | 'strakhovaniyeOtUkusaKleshcha'
    | 'stavki';

  /** Фильтрация по тэгу группы. */
  GroupTag?:
    | 'SAD'
    | 'test'
    | 'ыфввыф'
    | '333333333'
    | 'Decor'
    | 'Conditions'
    | 'bets-variety '
    | 'asdsaads'
    | 'strakhovaniyeOtUkusaKleshcha'
    | 'business'
    | 'bukhgalteriyaDlyaBiznesa'
    | 'other'
    | 'kursy'
    | 'Training_programs'
    | 'Payment'
    | 'Appp'
    | 'Insurance'
    | 'learning_process'
    | 'Support'
    | 'Vuvod_sredstv'
    | 'Uslovia_i_tarif'
    | 'Duration'
    | 'Functional'
    | 'Price'
    | 'Education'
    | '333'
    | '426822347';

  /** Включать удаленные */
  Deleted?: boolean;

  /** Заголовок/часть заголовка */
  Title?: string;

  /** Текст/часть текста */
  Text?: string;

  /**
   * дата с
   * @format date-time
   */
  From?: string;

  /**
   * дата по
   * @format date-time
   */
  To?: string;

  /** Роут локации отзыва */
  LocationRoute?: string;

  /** Роут локации отзыва нового формата */
  LocationGarRoute?: string;

  /**
   * id локации
   * @format int32
   */
  LocationId?: number;

  /**
   * GarId локации
   * @format int32
   */
  LocationGarId?: number;

  /** Статус оценки */
  RateStatus?: SravniReviewsEnumsReviewRateStatus;

  /**
   * Id отзыва (для списка комментариев)
   * @format int32
   */
  ReviewId?: number;

  /** статус комментария //todo: поправить нейминг */
  ReviewStatus?: SravniReviewsEnumsReviewStatus;

  /** статус наличия ответа от компании */
  HasCompanyResponse?: boolean;

  /** Id продукта любой витрины */
  SpecificProductId?: string;

  /** true - отзывы юриков; false - отзывы физиков; null - все отзывы */
  IsLegal?: boolean;

  /** true - есть персональные данные пользователя; false - нет персональных данных пользователя; null - все отзывы */
  HasPersonalData?: boolean;

  /** Предпочитать MongoID вместо INT */
  NewIds?: boolean;

  /** Возвращает по одному отзыву (если есть) на организацию */
  UniqueOnly?: boolean;

  /** Включать лайки? (не фильтр) */
  WithVotes?: boolean;

  /** Идентификаторы отзывов для поиска по айдишникам */
  ReviewIds?: number[];

  /** Идентификаторы пользователей */
  UserIds?: number[];

  /**
   * Индекс страницы
   * @format int32
   */
  PageIndex?: number;

  /**
   * Количество запрашиваемых сущностей
   * @format int32
   */
  PageSize?: number;
  fingerPrint?: string;
}

export interface HeadV2Params {
  organizationType?: SravniOrganizationsSharedReviewObjectType;
  organizationId?: string;
  reviewTag?: string;
  specificProductId?: string;

  /** Статусы проверки оценки отзыва */
  rateStatus?: SravniReviewsEnumsReviewRateStatus;
}

export interface ReviewsTagsDetailParams {
  /**
   * Дата начала периода
   * @format date-time
   */
  From?: string;

  /**
   * Дата окончания периода
   * @format date-time
   */
  To?: string;

  /** Тег отзыва */
  ServiceTag?:
    | 'unknown'
    | 'serviceLevel'
    | 'credits'
    | 'mortgage'
    | 'autocredits'
    | 'creditCards'
    | 'currencyExchange'
    | 'casco'
    | 'osago'
    | 'dsago'
    | 'homeInsurance'
    | 'travelInsurance'
    | 'moneyOrder'
    | 'greenCard'
    | 'priceQuality'
    | 'overallImpression'
    | 'aboutBuyingCarsFromAutoDealers'
    | 'microcredits'
    | 'debitCards'
    | 'remoteService'
    | 'businessDeposit'
    | 'businessCredits'
    | 'creditRefinancing'
    | 'investmentInsurance'
    | 'businessInsurance'
    | 'lifeInsurance'
    | 'responsibilityInsurance'
    | 'financialRiskInsurance'
    | 'pensionInsurance'
    | 'healthInsurance'
    | 'mortgageInsurance'
    | 'mortgageRefinancing'
    | 'businessRko'
    | 'factoring'
    | 'sportsInsurance'
    | 'acquiring'
    | 'business'
    | 'данные'
    | 'typeProgramming'
    | 'typeDesign'
    | 'typeManagement'
    | 'typeMarketing'
    | 'typeFinance'
    | 'typeAnalytics'
    | 'typeSoftSkills'
    | 'typeCreativity'
    | 'typeBeauty'
    | 'typeLanguage'
    | 'typeApplication'
    | 'sdelki'
    | 'otkrutie_scheta'
    | '654321'
    | '789'
    | '1547244'
    | '5723864'
    | 'Decor'
    | 'ApplicationAndWebsite'
    | 'ServiceErrors'
    | 'Interface'
    | 'Convenience'
    | 'Conditions'
    | 'techpodderzhka'
    | 'bonuses'
    | 'bets-variety '
    | 'Teachers'
    | 'Location'
    | 'Hostel'
    | 'Food'
    | 'other'
    | 'kursy'
    | 'Training_programs'
    | 'Payment'
    | 'Appp'
    | 'Insurance'
    | 'learning_process'
    | 'Support'
    | 'Vuvod_sredstv'
    | 'Uslovia_i_tarif'
    | 'Duration'
    | 'Functional'
    | 'Price'
    | 'Education'
    | 'egeOge'
    | 'dasdas'
    | 'asdsaads'
    | 'leasing'
    | 'biznesRegistration'
    | 'biznesNaMarketpleysakh'
    | 'bukhgalteriyaDlyaBiznesa'
    | 'savings'
    | '1234'
    | ' uslugaeda'
    | 'super-eda'
    | 'superedaeda'
    | '999367'
    | '9546738'
    | 'quality'
    | 'npf-fiz-uslugaa'
    | 'quality-of-food'
    | 'delivery'
    | 'package'
    | 'menu'
    | 'loyalty-program'
    | 'kittens'
    | 'strakhovaniyeOtUkusaKleshcha'
    | 'stavki';
  organizationId: string;
}

export interface ReviewsSeoListParams {
  /** Sravni.Organizations.Shared.ReviewObjectType */
  organizationType?: SravniOrganizationsSharedReviewObjectType;
}

export interface ReviewsSeoForSitemapListParams {
  ReviewObjectType?: SravniOrganizationsSharedReviewObjectType;

  /** @format int32 */
  ReviewTag?: number;

  /** @format date-time */
  From?: string;

  /** @format date-time */
  To?: string;
}

export interface ReviewsCountByOrganizationsListParams {
  /** Sravni.Organizations.Shared.ReviewObjectTypeТип интересующих организаций. Страховые итд */
  reviewObjectType?: SravniOrganizationsSharedReviewObjectType;
}

export interface ReviewsAggregatedReviewsCountListParams {
  /** Тип организации */
  OrganizationType?: SravniOrganizationsSharedReviewObjectType;

  /** Идентификатор организации */
  OrganizationId?: string;

  /** Код услуги */
  ServiceTag?:
    | 'unknown'
    | 'serviceLevel'
    | 'credits'
    | 'mortgage'
    | 'autocredits'
    | 'creditCards'
    | 'currencyExchange'
    | 'casco'
    | 'osago'
    | 'dsago'
    | 'homeInsurance'
    | 'travelInsurance'
    | 'moneyOrder'
    | 'greenCard'
    | 'priceQuality'
    | 'overallImpression'
    | 'aboutBuyingCarsFromAutoDealers'
    | 'microcredits'
    | 'debitCards'
    | 'remoteService'
    | 'businessDeposit'
    | 'businessCredits'
    | 'creditRefinancing'
    | 'investmentInsurance'
    | 'businessInsurance'
    | 'lifeInsurance'
    | 'responsibilityInsurance'
    | 'financialRiskInsurance'
    | 'pensionInsurance'
    | 'healthInsurance'
    | 'mortgageInsurance'
    | 'mortgageRefinancing'
    | 'businessRko'
    | 'factoring'
    | 'sportsInsurance'
    | 'acquiring'
    | 'business'
    | 'данные'
    | 'typeProgramming'
    | 'typeDesign'
    | 'typeManagement'
    | 'typeMarketing'
    | 'typeFinance'
    | 'typeAnalytics'
    | 'typeSoftSkills'
    | 'typeCreativity'
    | 'typeBeauty'
    | 'typeLanguage'
    | 'typeApplication'
    | 'sdelki'
    | 'otkrutie_scheta'
    | '654321'
    | '789'
    | '1547244'
    | '5723864'
    | 'Decor'
    | 'ApplicationAndWebsite'
    | 'ServiceErrors'
    | 'Interface'
    | 'Convenience'
    | 'Conditions'
    | 'techpodderzhka'
    | 'bonuses'
    | 'bets-variety '
    | 'Teachers'
    | 'Location'
    | 'Hostel'
    | 'Food'
    | 'other'
    | 'kursy'
    | 'Training_programs'
    | 'Payment'
    | 'Appp'
    | 'Insurance'
    | 'learning_process'
    | 'Support'
    | 'Vuvod_sredstv'
    | 'Uslovia_i_tarif'
    | 'Duration'
    | 'Functional'
    | 'Price'
    | 'Education'
    | 'egeOge'
    | 'dasdas'
    | 'asdsaads'
    | 'leasing'
    | 'biznesRegistration'
    | 'biznesNaMarketpleysakh'
    | 'bukhgalteriyaDlyaBiznesa'
    | 'savings'
    | '1234'
    | ' uslugaeda'
    | 'super-eda'
    | 'superedaeda'
    | '999367'
    | '9546738'
    | 'quality'
    | 'npf-fiz-uslugaa'
    | 'quality-of-food'
    | 'delivery'
    | 'package'
    | 'menu'
    | 'loyalty-program'
    | 'kittens'
    | 'strakhovaniyeOtUkusaKleshcha'
    | 'stavki';

  /** Код услуги */
  SpecificProductId?: string;

  /**
   * Идентификатор региона
   * @format int32
   */
  LocationId?: number;

  /**
   * Идентификатор региона (новый формат)
   * @format int32
   */
  LocationGarId?: number;
}

export interface SettingsFilterDetailParams {
  /** Пользователь физик или юрик. Важно только для банков. */
  isLegal?: boolean;

  /** Тип организации */
  objectType: SravniOrganizationsSharedReviewObjectType;
}

export interface SqueezeReviewsSqueezesListParams {
  /** Идентификатор организации */
  OrganizationId?: string;

  /** Услуга */
  Tag?:
    | 'unknown'
    | 'serviceLevel'
    | 'credits'
    | 'mortgage'
    | 'autocredits'
    | 'creditCards'
    | 'currencyExchange'
    | 'casco'
    | 'osago'
    | 'dsago'
    | 'homeInsurance'
    | 'travelInsurance'
    | 'moneyOrder'
    | 'greenCard'
    | 'priceQuality'
    | 'overallImpression'
    | 'aboutBuyingCarsFromAutoDealers'
    | 'microcredits'
    | 'debitCards'
    | 'remoteService'
    | 'businessDeposit'
    | 'businessCredits'
    | 'creditRefinancing'
    | 'investmentInsurance'
    | 'businessInsurance'
    | 'lifeInsurance'
    | 'responsibilityInsurance'
    | 'financialRiskInsurance'
    | 'pensionInsurance'
    | 'healthInsurance'
    | 'mortgageInsurance'
    | 'mortgageRefinancing'
    | 'businessRko'
    | 'factoring'
    | 'sportsInsurance'
    | 'acquiring'
    | 'business'
    | 'данные'
    | 'typeProgramming'
    | 'typeDesign'
    | 'typeManagement'
    | 'typeMarketing'
    | 'typeFinance'
    | 'typeAnalytics'
    | 'typeSoftSkills'
    | 'typeCreativity'
    | 'typeBeauty'
    | 'typeLanguage'
    | 'typeApplication'
    | 'sdelki'
    | 'otkrutie_scheta'
    | '654321'
    | '789'
    | '1547244'
    | '5723864'
    | 'Decor'
    | 'ApplicationAndWebsite'
    | 'ServiceErrors'
    | 'Interface'
    | 'Convenience'
    | 'Conditions'
    | 'techpodderzhka'
    | 'bonuses'
    | 'bets-variety '
    | 'Teachers'
    | 'Location'
    | 'Hostel'
    | 'Food'
    | 'other'
    | 'kursy'
    | 'Training_programs'
    | 'Payment'
    | 'Appp'
    | 'Insurance'
    | 'learning_process'
    | 'Support'
    | 'Vuvod_sredstv'
    | 'Uslovia_i_tarif'
    | 'Duration'
    | 'Functional'
    | 'Price'
    | 'Education'
    | 'egeOge'
    | 'dasdas'
    | 'asdsaads'
    | 'leasing'
    | 'biznesRegistration'
    | 'biznesNaMarketpleysakh'
    | 'bukhgalteriyaDlyaBiznesa'
    | 'savings'
    | '1234'
    | ' uslugaeda'
    | 'super-eda'
    | 'superedaeda'
    | '999367'
    | '9546738'
    | 'quality'
    | 'npf-fiz-uslugaa'
    | 'quality-of-food'
    | 'delivery'
    | 'package'
    | 'menu'
    | 'loyalty-program'
    | 'kittens'
    | 'strakhovaniyeOtUkusaKleshcha'
    | 'stavki';

  /** Айдишник продукта с витрины */
  SpecificProductId?: string;

  /** Признак того, что выжимка является позитивной или негативной */
  IsPositive?: boolean;

  /**
   * Индекс страницы
   * @format int32
   */
  PageIndex?: number;

  /**
   * Количество запрашиваемых сущностей
   * @format int32
   */
  PageSize?: number;
}

export interface SqueezeVectorsListParams {
  /** Текст для поиска */
  Text?: string;

  /** Тип организации к которой он относится */
  ReviewObjectType?: SravniOrganizationsSharedReviewObjectType;

  /** Признак позитивного / негативного */
  IsPositive?: boolean;

  /**
   * Индекс страницы
   * @format int32
   */
  PageIndex?: number;

  /**
   * Количество запрашиваемых сущностей
   * @format int32
   */
  PageSize?: number;
}

export interface SqueezeVectorListParams {
  /** @format int32 */
  id?: number;
}

export interface SqueezeDeleteVectorUpdateParams {
  /** @format int32 */
  id?: number;
}

export interface SqueezeDeleteVectorDeleteParams {
  /** @format int32 */
  id?: number;
}

export interface SqueezeRestoreVectorUpdateParams {
  /** @format int32 */
  id?: number;
}

export interface SqueezeListParams {
  /** Текст для поиска */
  Text?: string;

  /** Текст для поиска по тексту вектора (если есть) */
  VectorText?: string;

  /** Тип организации к которой она относится */
  ReviewObjectType?: SravniOrganizationsSharedReviewObjectType;

  /** Признак позитивного / негативного */
  IsPositive?: boolean;

  /** Признак обязательного наличия или отсуствия вектора */
  IsVectorExist?: boolean;

  /**
   * Индекс страницы
   * @format int32
   */
  PageIndex?: number;

  /**
   * Количество запрашиваемых сущностей
   * @format int32
   */
  PageSize?: number;
}

export interface TagsListParams {
  /** Возвращает тег по подстроке в имени или алисе */
  Term?: string;

  /** Продуктовый заголовок тега */
  Title?: string;

  /** Возвращает теги, соответствующие указанному продуктовому тегу */
  ServiceTag?:
    | 'unknown'
    | 'serviceLevel'
    | 'credits'
    | 'mortgage'
    | 'autocredits'
    | 'creditCards'
    | 'currencyExchange'
    | 'casco'
    | 'osago'
    | 'dsago'
    | 'homeInsurance'
    | 'travelInsurance'
    | 'moneyOrder'
    | 'greenCard'
    | 'priceQuality'
    | 'overallImpression'
    | 'aboutBuyingCarsFromAutoDealers'
    | 'microcredits'
    | 'debitCards'
    | 'remoteService'
    | 'businessDeposit'
    | 'businessCredits'
    | 'creditRefinancing'
    | 'investmentInsurance'
    | 'businessInsurance'
    | 'lifeInsurance'
    | 'responsibilityInsurance'
    | 'financialRiskInsurance'
    | 'pensionInsurance'
    | 'healthInsurance'
    | 'mortgageInsurance'
    | 'mortgageRefinancing'
    | 'businessRko'
    | 'factoring'
    | 'sportsInsurance'
    | 'acquiring'
    | 'business'
    | 'данные'
    | 'typeProgramming'
    | 'typeDesign'
    | 'typeManagement'
    | 'typeMarketing'
    | 'typeFinance'
    | 'typeAnalytics'
    | 'typeSoftSkills'
    | 'typeCreativity'
    | 'typeBeauty'
    | 'typeLanguage'
    | 'typeApplication'
    | 'sdelki'
    | 'otkrutie_scheta'
    | '654321'
    | '789'
    | '1547244'
    | '5723864'
    | 'Decor'
    | 'ApplicationAndWebsite'
    | 'ServiceErrors'
    | 'Interface'
    | 'Convenience'
    | 'Conditions'
    | 'techpodderzhka'
    | 'bonuses'
    | 'bets-variety '
    | 'Teachers'
    | 'Location'
    | 'Hostel'
    | 'Food'
    | 'other'
    | 'kursy'
    | 'Training_programs'
    | 'Payment'
    | 'Appp'
    | 'Insurance'
    | 'learning_process'
    | 'Support'
    | 'Vuvod_sredstv'
    | 'Uslovia_i_tarif'
    | 'Duration'
    | 'Functional'
    | 'Price'
    | 'Education'
    | 'egeOge'
    | 'dasdas'
    | 'asdsaads'
    | 'leasing'
    | 'biznesRegistration'
    | 'biznesNaMarketpleysakh'
    | 'bukhgalteriyaDlyaBiznesa'
    | 'savings'
    | '1234'
    | ' uslugaeda'
    | 'super-eda'
    | 'superedaeda'
    | '999367'
    | '9546738'
    | 'quality'
    | 'npf-fiz-uslugaa'
    | 'quality-of-food'
    | 'delivery'
    | 'package'
    | 'menu'
    | 'loyalty-program'
    | 'kittens'
    | 'strakhovaniyeOtUkusaKleshcha'
    | 'stavki';

  /**
   * Возвращает теги определенного отзыва
   * @format int32
   */
  ReviewId?: number;

  /** Возвращает либо позитивные, либо негативные теги. Если null - вернет все. */
  IsPositive?: boolean;

  /** Вернуть только валидные теги, или вместе с удалеными */
  PublicOnly?: boolean;

  /**
   * Индекс страницы
   * @format int32
   */
  PageIndex?: number;

  /**
   * Количество запрашиваемых сущностей
   * @format int32
   */
  PageSize?: number;
}

export interface TagProductTagListParams {
  /** наименование тега, ищет по подстроке */
  name?: string;
}

export interface UnpublishedCommentsListParams {
  /** Ids отзывов */
  ReviewIds?: number[];

  /** Ids комментариев */
  CommentIds?: number[];

  /**
   * Индекс страницы
   * @format int32
   */
  PageIndex?: number;

  /**
   * Количество запрашиваемых сущностей
   * @format int32
   */
  PageSize?: number;
}

export interface UnpublishedCommentDeleteParams {
  /** @format int32 */
  id?: number;
}

export interface ActivityDetailParams {
  /** Признак исключения отзывов */
  ExcludeReviews?: boolean;

  /** Признак исключения комментариев */
  ExcludeComments?: boolean;

  /**
   * Индекс страницы
   * @format int32
   */
  PageIndex?: number;

  /**
   * Количество запрашиваемых сущностей
   * @format int32
   */
  PageSize?: number;

  /** @format int32 */
  id: number;
}

export interface ActivityByServiceDetailParams {
  /** Признак исключения отзывов */
  ExcludeReviews?: boolean;

  /** Признак исключения комментариев */
  ExcludeComments?: boolean;

  /**
   * Индекс страницы
   * @format int32
   */
  PageIndex?: number;

  /**
   * Количество запрашиваемых сущностей
   * @format int32
   */
  PageSize?: number;

  /** @format int32 */
  id: number;
}

export interface ViewsReviewsListParams {
  ids?: number[];
}

export interface VotesForReviewsListParams {
  /** Ids отзывов. От 1 до 20 элементов */
  ReviewIds?: number[];

  /** Поиск голосов по Fingerprint, у неавторизованного пользователя */
  Fingerprint?: string;
}
